var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Mesa_de_trabajo_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mesa_de_trabajo_1",
    "data-name": "Mesa de trabajo 1",
    clipPath: "url(#clip-Mesa_de_trabajo_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "create-account",
    transform: "translate(6.241 103.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete",
    "data-name": "Background Complete",
    transform: "translate(-6.241 -103.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 105.349,
    height: 99.917,
    rx: 6.79,
    transform: "translate(332.223 65.949) rotate(-12.488)",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M414.935,114.2a4.2,4.2,0,0,1-.681.2l-1.981.487-7.354,1.722-24.72,5.618-.2.046-.074-.194-1.492-3.97c-4.33-11.632-8.194-22.013-10.72-28.8l.175.1-6.6,1.408-1.762.354a3.51,3.51,0,0,1-.613.094,3.466,3.466,0,0,1,.6-.177l1.744-.431,6.573-1.544.128-.03L368,89.2c2.564,6.77,6.488,17.129,10.885,28.736l1.489,3.97-.275-.148,24.754-5.467,7.385-1.58,2-.4A4.158,4.158,0,0,1,414.935,114.2Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M377.526,115.012a.637.637,0,0,1,.17-.058l.509-.134,1.981-.483,7.431-1.734,25.654-5.834-.179.234c-.208-4.492-.432-9.349-.664-14.376-.117-2.585-.232-5.126-.341-7.549l.288.221L382.1,92l-8.974,1.937-2.423.5-.63.119a.867.867,0,0,1-.218.026.806.806,0,0,1,.208-.07l.621-.161,2.4-.581,8.942-2.077,30.241-6.857.276-.063.013.283c.111,2.422.227,4.963.346,7.549.225,5.027.443,9.884.644,14.376l.009.193-.188.042-25.691,5.668-7.46,1.6-2,.409-.517.1A.565.565,0,0,1,377.526,115.012Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M390.96,129.487c-.043.011-.114-.3-.382-.783a3.559,3.559,0,0,0-1.682-1.521,3.36,3.36,0,1,0,1.18,5.268,3.556,3.556,0,0,0,.872-2.093c.037-.552-.031-.863.012-.871a1.8,1.8,0,0,1,.175.876,3.551,3.551,0,0,1-.8,2.306A3.722,3.722,0,0,1,387,134.018a3.771,3.771,0,0,1-1.555-6.939,3.719,3.719,0,0,1,3.592-.2,3.548,3.548,0,0,1,1.707,1.744A1.811,1.811,0,0,1,390.96,129.487Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M413.349,124.471c-.043.011-.114-.3-.383-.783a3.554,3.554,0,0,0-1.682-1.521,3.36,3.36,0,1,0,1.181,5.268,3.565,3.565,0,0,0,.872-2.093c.037-.552-.032-.863.012-.871a1.811,1.811,0,0,1,.174.876,3.546,3.546,0,0,1-.8,2.305,3.72,3.72,0,0,1-3.335,1.35,3.771,3.771,0,0,1-1.555-6.94,3.719,3.719,0,0,1,3.592-.2,3.548,3.548,0,0,1,1.707,1.744A1.809,1.809,0,0,1,413.349,124.471Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M419.559,79.751a10.173,10.173,0,1,1-12.151-7.7A10.174,10.174,0,0,1,419.559,79.751Z",
    fill: "#fafafa"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M414.192,77.061a9.229,9.229,0,0,1-.929,1.89c-.625,1.136-1.519,2.688-2.53,4.387l-1.089,1.808-.114.19-.191-.106a32.8,32.8,0,0,1-4.339-2.6,33.111,33.111,0,0,1,4.556,2.2l-.3.084,1.07-1.818c1.012-1.7,1.951-3.225,2.652-4.316A9.18,9.18,0,0,1,414.192,77.061Z",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M72.285,194.377c-1.845-6.534-10.337-5.9-10.337-5.9l.234,4.544c4.908-.847,7.959,4.906,7.959,4.906Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M196.975,118.944c9.85,2.984,15.979-8.376,15.979-8.376l-5.993-3.415c-2.93,6.959-12.768,6.154-12.768,6.154Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M278.741,179.926c-1.9-5.432-9.058-4.447-9.058-4.447l.437,3.833c4.11-.976,6.995,3.732,6.995,3.732Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M165.762,52.683c-1.906-5.432-9.058-4.448-9.058-4.448l.437,3.834c4.109-.976,6.994,3.731,6.994,3.731Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M80.421,122.192c-1.906-5.433-9.058-4.448-9.058-4.448l.437,3.833c4.109-.975,6.995,3.732,6.995,3.732Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M62.49,71.409c-5.681.932-5.955,8.147-5.955,8.147l3.851.236c-.246-4.216,4.891-6.239,4.891-6.239Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M21.592,240.394c9.85,2.984,15.978-8.377,15.978-8.377L31.577,228.6c-2.929,6.959-12.767,6.154-12.767,6.154Z",
    fill: "#ebebeb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M302.2,119.572c.666-4.561-4.774-6.52-4.774-6.52l-1.113,2.882c3.277.834,3.575,5.245,3.575,5.245Z",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M269.453,69.475c-3.841,2.549-1.667,7.907-1.667,7.907l2.889-1.1c-1.567-3,1.518-6.164,1.518-6.164Z",
    fill: "#ebebeb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M436.084,171.565l-13.3,39.166,39.326,7.815,2.263-41.359Z",
    fill: "#f5f5f5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M460.022,182.39c.046.019-.074.438-.442,1.123a11.449,11.449,0,0,1-1.98,2.632,10.751,10.751,0,0,1-4.168,2.6,11.731,11.731,0,0,1-6,.3,11.946,11.946,0,0,1-5.486-2.467,9.6,9.6,0,0,1-2.815-4.029,10.7,10.7,0,0,1-.676-3.226,2.666,2.666,0,0,1,.091-1.2,18.708,18.708,0,0,0,1.07,4.234,9.5,9.5,0,0,0,2.765,3.7,11.7,11.7,0,0,0,5.187,2.264,11.461,11.461,0,0,0,5.66-.226,10.821,10.821,0,0,0,4.016-2.327A20.979,20.979,0,0,0,460.022,182.39Z",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete-2",
    "data-name": "Background_Complete",
    transform: "translate(39.811 37.601)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_306",
    "data-name": "Group 306",
    transform: "translate(4.36 0.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_305",
    "data-name": "Group 305"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_304",
    "data-name": "Group 304"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_301",
    "data-name": "Group 301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_300",
    "data-name": "Group 300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_299",
    "data-name": "Group 299"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_298",
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 64.085,
    height: 66.803,
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_325",
    "data-name": "Group 325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_315",
    "data-name": "Group 315",
    transform: "translate(0.02 0.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_314",
    "data-name": "Group 314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_313",
    "data-name": "Group 313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_312",
    "data-name": "Group 312"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_311",
    "data-name": "Group 311"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_310",
    "data-name": "Group 310"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_309",
    "data-name": "Group 309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_307",
    "data-name": "Group 307"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 64.085,
    height: 66.803,
    fill: "#fafafa"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_324",
    "data-name": "Group 324"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_323",
    "data-name": "Group 323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_322",
    "data-name": "Group 322"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_321",
    "data-name": "Group 321"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_320",
    "data-name": "Group 320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_319",
    "data-name": "Group 319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_318",
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_317",
    "data-name": "Group 317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_316",
    "data-name": "Group 316"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M103.936,104.444H39.811V37.6h64.125Zm-64.085-.04H103.9V37.641H39.851Z",
    transform: "translate(-39.811 -37.601)",
    fill: "#e0e0e0"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_335",
    "data-name": "Group 335",
    transform: "translate(8.635 9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_333",
    "data-name": "Group 333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_332",
    "data-name": "Group 332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_331",
    "data-name": "Group 331"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_330",
    "data-name": "Group 330"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_329",
    "data-name": "Group 329"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_327",
    "data-name": "Group 327"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_326",
    "data-name": "Group 326"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 46.855,
    height: 48.843,
    fill: "#fff"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(0.082 58.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_345",
    "data-name": "Group 345"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_344",
    "data-name": "Group 344"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_343",
    "data-name": "Group 343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_342",
    "data-name": "Group 342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_341",
    "data-name": "Group 341"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_340",
    "data-name": "Group 340"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_339",
    "data-name": "Group 339"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_338",
    "data-name": "Group 338"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_337",
    "data-name": "Group 337"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_336",
    "data-name": "Group 336"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M48.5,135.1a7.655,7.655,0,0,1-1.156,1.344c-.748.79-1.8,1.858-2.979,3.019s-2.262,2.2-3.061,2.93a7.456,7.456,0,0,1-1.354,1.128,7.425,7.425,0,0,1,1.15-1.339c.748-.789,1.8-1.861,2.985-3.025s2.268-2.2,3.066-2.935A7.31,7.31,0,0,1,48.5,135.1Z",
    transform: "translate(-39.949 -135.101)",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_357",
    "data-name": "Group 357",
    transform: "translate(55.487 58.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_356",
    "data-name": "Group 356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_355",
    "data-name": "Group 355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_354",
    "data-name": "Group 354"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_353",
    "data-name": "Group 353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_352",
    "data-name": "Group 352"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_351",
    "data-name": "Group 351"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_350",
    "data-name": "Group 350"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_349",
    "data-name": "Group 349"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_348",
    "data-name": "Group 348"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_347",
    "data-name": "Group 347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M132.825,134.9a7.644,7.644,0,0,1,1.345,1.156c.79.749,1.858,1.8,3.019,2.979s2.2,2.262,2.93,3.061a7.456,7.456,0,0,1,1.128,1.354,7.459,7.459,0,0,1-1.339-1.15c-.789-.749-1.861-1.8-3.026-2.985s-2.2-2.268-2.935-3.067A7.374,7.374,0,0,1,132.825,134.9Z",
    transform: "translate(-132.822 -134.901)",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(55.36 0.706)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_367",
    "data-name": "Group 367"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_366",
    "data-name": "Group 366"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_365",
    "data-name": "Group 365"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_364",
    "data-name": "Group 364"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_363",
    "data-name": "Group 363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_362",
    "data-name": "Group 362"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_361",
    "data-name": "Group 361"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_360",
    "data-name": "Group 360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_359",
    "data-name": "Group 359"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    "data-name": "Group 358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    d: "M132.612,47.209a7.644,7.644,0,0,1,1.156-1.345c.748-.79,1.8-1.858,2.979-3.019s2.262-2.2,3.061-2.93a7.4,7.4,0,0,1,1.354-1.128,7.513,7.513,0,0,1-1.15,1.339c-.748.79-1.8,1.861-2.985,3.025s-2.268,2.2-3.067,2.936A7.3,7.3,0,0,1,132.612,47.209Z",
    transform: "translate(-132.609 -38.784)",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_379",
    "data-name": "Group 379",
    transform: "translate(0.083 0.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_378",
    "data-name": "Group 378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_376",
    "data-name": "Group 376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_375",
    "data-name": "Group 375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_374",
    "data-name": "Group 374"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_373",
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_372",
    "data-name": "Group 372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_371",
    "data-name": "Group 371"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M48.373,47.323a7.654,7.654,0,0,1-1.344-1.156c-.79-.748-1.858-1.8-3.019-2.979s-2.2-2.262-2.93-3.061a7.456,7.456,0,0,1-1.128-1.354,7.459,7.459,0,0,1,1.339,1.15c.79.748,1.861,1.8,3.025,2.985s2.2,2.268,2.935,3.067A7.31,7.31,0,0,1,48.373,47.323Z",
    transform: "translate(-39.95 -38.771)",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_390",
    "data-name": "Group 390",
    transform: "translate(8.428 8.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_389",
    "data-name": "Group 389"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_388",
    "data-name": "Group 388"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_387",
    "data-name": "Group 387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_386",
    "data-name": "Group 386"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_385",
    "data-name": "Group 385"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_384",
    "data-name": "Group 384"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_383",
    "data-name": "Group 383"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_382",
    "data-name": "Group 382"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_381",
    "data-name": "Group 381"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_380",
    "data-name": "Group 380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M100.873,101.391a2.265,2.265,0,0,1-.01-.237c0-.166-.006-.391-.01-.682,0-.613-.012-1.493-.021-2.637-.011-2.314-.027-5.68-.047-9.954-.022-8.555-.054-20.741-.092-35.333l.181.181-46.723.027h0l.208-.208c-.011,17.927-.021,34.7-.029,48.843l-.178-.178,33.834.091,9.5.047,2.515.021.65.01c.147,0,.223.007.226.01a1.47,1.47,0,0,1-.206.01l-.631.01-2.481.021-9.463.047-33.947.091h-.178v-.179c-.008-14.144-.018-30.915-.029-48.843v-.208h.212l46.723.027h.181v.181c-.038,14.64-.07,26.866-.092,35.448-.021,4.257-.036,7.609-.048,9.914q-.013,1.693-.021,2.6c0,.282-.008.5-.01.662A1.654,1.654,0,0,1,100.873,101.391Z",
    transform: "translate(-53.938 -52.341)",
    fill: "#e0e0e0"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_400",
    "data-name": "Group 400",
    transform: "translate(24.245 25.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_399",
    "data-name": "Group 399"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_398",
    "data-name": "Group 398"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_397",
    "data-name": "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_396",
    "data-name": "Group 396"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_395",
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_394",
    "data-name": "Group 394"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_393",
    "data-name": "Group 393"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_392",
    "data-name": "Group 392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_391",
    "data-name": "Group 391"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 15.635,
    height: 15.635,
    fill: "#ebebeb"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_463",
    "data-name": "Group 463",
    transform: "translate(297.796 3.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    transform: "translate(0.412)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_404",
    "data-name": "Group 404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M629.548,42.771v60.39H542.811l-3.125-59.968Z",
    transform: "translate(-539.686 -42.771)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(0 0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    transform: "translate(0.412 0.411)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 59.841,
    height: 86.736,
    transform: "translate(0 59.841) rotate(-90)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M626.556,103.453H539V42.79h87.56Zm-86.736-.823h85.914V43.613H539.819Z",
    transform: "translate(-538.996 -42.79)",
    fill: "#e0e0e0"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(9.592 7.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(0.214 0.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 67.948,
    height: 44.971,
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M623.236,55.809s-.117.008-.335.011l-.966.011-3.732.024-14,.053-48.913.1.2-.2c.005,13.74.011,28.964.018,44.965v.005l-.214-.214,67.948.044-.171.171c.038-13.686.069-24.907.089-32.72.018-3.905.033-6.957.044-9.048q.012-1.55.019-2.377c.007-.539.019-.825.019-.825s.013.262.019.789q.006.815.019,2.346c.01,2.083.024,5.121.044,9.01.021,7.839.052,19.1.089,32.827v.171h-.171l-67.948.044h-.214v-.22c.007-16,.013-31.225.018-44.965v-.2h.2l49.042.1,13.958.053,3.692.024.944.011C623.135,55.8,623.236,55.809,623.236,55.809Z",
    transform: "translate(-555.074 -55.613)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(0.41 0.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_431",
    "data-name": "Group 431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_430",
    "data-name": "Group 430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M539.685,43.2a7.343,7.343,0,0,1,1.491.966c.887.641,2.1,1.549,3.4,2.593s2.453,2.032,3.26,2.772a7.041,7.041,0,0,1,1.242,1.271c-.081.091-2.166-1.629-4.771-3.709A47.33,47.33,0,0,1,539.685,43.2Z",
    transform: "translate(-539.683 -43.191)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_439",
    "data-name": "Group 439",
    transform: "translate(77.752 0.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_438",
    "data-name": "Group 438"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_437",
    "data-name": "Group 437"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_434",
    "data-name": "Group 434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M678.725,43.476a41.988,41.988,0,0,1-4.564,3.885,42.1,42.1,0,0,1-4.83,3.55,42.037,42.037,0,0,1,4.564-3.885A42.15,42.15,0,0,1,678.725,43.476Z",
    transform: "translate(-669.329 -43.473)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_451",
    "data-name": "Group 451",
    transform: "translate(77.407 52.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_444",
    "data-name": "Group 444",
    transform: "translate(0.002 0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_443",
    "data-name": "Group 443"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_442",
    "data-name": "Group 442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_441",
    "data-name": "Group 441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_440",
    "data-name": "Group 440"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M678.424,138.5l-9.671-7.838",
    transform: "translate(-668.753 -130.664)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_450",
    "data-name": "Group 450"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_449",
    "data-name": "Group 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_448",
    "data-name": "Group 448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_447",
    "data-name": "Group 447"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_446",
    "data-name": "Group 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_445",
    "data-name": "Group 445"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M668.752,130.662a45.37,45.37,0,0,1,4.97,3.752,45.389,45.389,0,0,1,4.7,4.086,45.432,45.432,0,0,1-4.971-3.753A45.529,45.529,0,0,1,668.752,130.662Z",
    transform: "translate(-668.75 -130.658)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_457",
    "data-name": "Group 457",
    transform: "translate(0.41 52.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_456",
    "data-name": "Group 456"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_455",
    "data-name": "Group 455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_454",
    "data-name": "Group 454"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_453",
    "data-name": "Group 453"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_452",
    "data-name": "Group 452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M539.685,138.812a41.14,41.14,0,0,1,4.516-3.845,41.129,41.129,0,0,1,4.782-3.509,41.125,41.125,0,0,1-4.517,3.845A41.119,41.119,0,0,1,539.685,138.812Z",
    transform: "translate(-539.683 -131.454)",
    fill: "#e0e0e0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_462",
    "data-name": "Group 462",
    transform: "translate(23.602 21.869)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_461",
    "data-name": "Group 461",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_460",
    "data-name": "Group 460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_459",
    "data-name": "Group 459"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_458",
    "data-name": "Group 458"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 15.058,
    height: 42.754,
    transform: "translate(0 15.058) rotate(-90)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(73.987 205.789)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_499",
    "data-name": "Group 499"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_470",
    "data-name": "Group 470",
    transform: "translate(3.711 8.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_469",
    "data-name": "Group 469"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_468",
    "data-name": "Group 468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_467",
    "data-name": "Group 467"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_466",
    "data-name": "Group 466"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_465",
    "data-name": "Group 465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_464",
    "data-name": "Group 464"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M170.053,396.036V424.8h88.452V396.036Z",
    transform: "translate(-170.053 -396.036)",
    fill: "#f5f5f5"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_477",
    "data-name": "Group 477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_476",
    "data-name": "Group 476"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_475",
    "data-name": "Group 475"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_474",
    "data-name": "Group 474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_473",
    "data-name": "Group 473"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_472",
    "data-name": "Group 472"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_471",
    "data-name": "Group 471"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M163.833,382.557V390.6h95.255v-8.041H163.833Z",
    transform: "translate(-163.833 -382.557)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_484",
    "data-name": "Group 484",
    transform: "translate(45.771)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_482",
    "data-name": "Group 482"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_481",
    "data-name": "Group 481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_480",
    "data-name": "Group 480"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_479",
    "data-name": "Group 479"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_478",
    "data-name": "Group 478"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M242.414,419.36h44.535V390.6h3.093v-8.041H240.558v7.3Z",
    transform: "translate(-240.558 -382.557)",
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    "data-name": "Group 491",
    transform: "translate(16.082 12.679)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_490",
    "data-name": "Group 490"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_489",
    "data-name": "Group 489"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_488",
    "data-name": "Group 488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_487",
    "data-name": "Group 487"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_486",
    "data-name": "Group 486"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_485",
    "data-name": "Group 485"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 17.938,
    height: 4.329,
    fill: "#e0e0e0"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498",
    transform: "translate(13.773 22.422)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_497",
    "data-name": "Group 497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_496",
    "data-name": "Group 496"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_495",
    "data-name": "Group 495"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_494",
    "data-name": "Group 494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_493",
    "data-name": "Group 493"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    "data-name": "Group 492"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 23.033,
    height: 9.142,
    fill: "#fff"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(319.998 93.248)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516",
    transform: "translate(5.265 55.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505",
    transform: "translate(0 13.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_504",
    "data-name": "Group 504"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_503",
    "data-name": "Group 503"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_502",
    "data-name": "Group 502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_501",
    "data-name": "Group 501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M605.367,309.164l-20.329,82.2h5.351l20.83-82.2Z",
    transform: "translate(-585.038 -309.164)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510",
    transform: "translate(52.767 13.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M679.341,309.164l19.021,82.2h-5.351l-19.522-82.2Z",
    transform: "translate(-673.489 -309.164)",
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515",
    transform: "translate(35.569)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M651.817,381.124h-6.229l-.928-94.341h6.229Z",
    transform: "translate(-644.661 -286.783)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 87.897,
    height: 56.313,
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526",
    transform: "translate(21.915 67.893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 44.118,
    height: 5.438,
    fill: "#f5f5f5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532",
    transform: "translate(5.625 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M585.858,245.3a6.121,6.121,0,0,1,.06,1.03H585.8c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a.243.243,0,1,1,.087,0c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.016,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.12A6.136,6.136,0,0,1,585.858,245.3Z",
    transform: "translate(-585.641 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    transform: "translate(12.167 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M596.823,245.3a6.089,6.089,0,0,1,.06,1.03h-.121c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a2.047,2.047,0,0,1,.044-.482,2.019,2.019,0,0,1,.043.482c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.016,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.12A6.159,6.159,0,0,1,596.823,245.3Z",
    transform: "translate(-596.607 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(18.709 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M607.79,245.3a6.112,6.112,0,0,1,.06,1.03h-.121c-.091-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a2.062,2.062,0,0,1,.044-.482,2.013,2.013,0,0,1,.044.482c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.121A6.153,6.153,0,0,1,607.79,245.3Z",
    transform: "translate(-607.573 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(25.251 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M618.755,245.3a6.1,6.1,0,0,1,.06,1.03h-.12c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a2.058,2.058,0,0,1,.044-.482,2.016,2.016,0,0,1,.044.482c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.121A6.134,6.134,0,0,1,618.755,245.3Z",
    transform: "translate(-618.539 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(31.793 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M629.722,245.3a6.118,6.118,0,0,1,.06,1.03h-.12c-.091-2.754-.156-11.878-.156-22.692.025-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a.243.243,0,1,1,.087,0c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.12A6.134,6.134,0,0,1,629.722,245.3Z",
    transform: "translate(-629.505 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(38.335 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M640.688,245.3a6.118,6.118,0,0,1,.06,1.03h-.12c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a2.013,2.013,0,0,1,.044-.482,2.062,2.062,0,0,1,.044.482c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.016,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.12A6.1,6.1,0,0,1,640.688,245.3Z",
    transform: "translate(-640.471 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    transform: "translate(44.877 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M651.654,245.3a6.1,6.1,0,0,1,.06,1.03h-.12c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a.243.243,0,1,1,.087,0c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.121A6.162,6.162,0,0,1,651.654,245.3Z",
    transform: "translate(-651.437 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(51.419 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M662.62,245.3a6.089,6.089,0,0,1,.06,1.03h-.121c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a2.02,2.02,0,0,1,.044-.482,2.047,2.047,0,0,1,.044.482c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.064,16.776,0,10.813-.066,19.937-.156,22.692h-.12A6.14,6.14,0,0,1,662.62,245.3Z",
    transform: "translate(-662.403 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(57.96 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M673.586,245.3a6.1,6.1,0,0,1,.06,1.03h-.12c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a.243.243,0,1,1,.087,0c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.12A6.159,6.159,0,0,1,673.586,245.3Z",
    transform: "translate(-673.369 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(64.502 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M684.552,245.3a6.112,6.112,0,0,1,.06,1.03h-.121c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a.243.243,0,1,1,.087,0c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.121A6.153,6.153,0,0,1,684.552,245.3Z",
    transform: "translate(-684.335 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(71.044 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M695.518,245.3a6.118,6.118,0,0,1,.06,1.03h-.12c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a.243.243,0,1,1,.087,0c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.121A6.108,6.108,0,0,1,695.518,245.3Z",
    transform: "translate(-695.301 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(77.586 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M706.484,245.3a6.106,6.106,0,0,1,.06,1.03h-.121c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a.243.243,0,1,1,.087,0c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.016,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.121A6.162,6.162,0,0,1,706.484,245.3Z",
    transform: "translate(-706.267 -199.913)",
    fill: "#f5f5f5"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(84.128 3.581)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M717.45,245.3a6.118,6.118,0,0,1,.06,1.03h-.12c-.09-2.754-.156-11.878-.156-22.692.024-6.525.047-12.43.063-16.776.029-2.1.052-3.824.069-5.084.017-.561.03-1.018.041-1.382a2.02,2.02,0,0,1,.044-.482,2.053,2.053,0,0,1,.044.482c.011.363.024.821.041,1.382.017,1.259.041,2.982.069,5.084.017,4.346.039,10.251.063,16.776,0,10.813-.066,19.937-.156,22.692h-.12A6.145,6.145,0,0,1,717.45,245.3Z",
    transform: "translate(-717.233 -199.913)",
    fill: "#f5f5f5"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(50.47 280.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M436.285,444.144c0,.086-84.761.155-189.294.155-104.57,0-189.313-.07-189.313-.155s84.743-.155,189.313-.155C351.524,443.989,436.285,444.058,436.285,444.144Z",
    transform: "translate(-57.678 -443.989)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Screen",
    transform: "translate(83.891 75.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    transform: "translate(0.156 0.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 286.16,
    height: 142.175,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    transform: "translate(0.156 0.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    width: 286.16,
    height: 17.639,
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M400.017,243.888c0-.915-.044-54.5-.115-142.175l.115.115-286.14.04h-.02l.155-.155c0,50.114-.006,98.214-.009,142.175l-.146-.146,286.16.146-286.16.146h-.147v-.147c0-43.961-.006-92.061-.009-142.175v-.155h.175l286.14.04h.115v.115C400.061,189.387,400.018,242.974,400.017,243.888Z",
    transform: "translate(-113.701 -101.557)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    transform: "translate(22.637 53.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    transform: "translate(0.154 0.155)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M384.849,225.8H155.193a3.287,3.287,0,0,1-3.288-3.288V194.558a3.287,3.287,0,0,1,3.288-3.288H384.849a3.287,3.287,0,0,1,3.288,3.288v27.953A3.288,3.288,0,0,1,384.849,225.8Z",
    transform: "translate(-151.905 -191.27)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M384.744,225.694a3.5,3.5,0,0,0,1.336-.3,3.275,3.275,0,0,0,1.3-1.06,3.357,3.357,0,0,0,.625-2.206c-.007-3.573-.017-8.836-.029-15.613,0-3.39-.008-7.158-.014-11.283a6.314,6.314,0,0,0-.1-1.537,3.212,3.212,0,0,0-2.019-2.251,3.306,3.306,0,0,0-.784-.181c-.267-.019-.547-.016-.827-.015l-6.969.007-32.717.023-189.444.045a3.139,3.139,0,0,0-3.146,3.148v8.6q0,6.851,0,13.609v5.053a5.147,5.147,0,0,0,.144,1.617,3.148,3.148,0,0,0,2.222,2.095,6.577,6.577,0,0,0,1.622.1H170.8l50.3.009,85.169.033,57.418.05,15.611.029,4.06.016c.915,0,1.383.016,1.383.016s-.468.011-1.383.016l-4.06.016-15.611.029-57.418.05-85.169.033-50.3.009h-15.7a3.605,3.605,0,0,1-.863-.108,3.455,3.455,0,0,1-2.44-2.3,5.429,5.429,0,0,1-.159-1.709v-5.053q0-6.756,0-13.609v-8.6a3.45,3.45,0,0,1,3.456-3.459l189.444.045,32.717.023,6.969.007c.28,0,.557,0,.842.017a3.411,3.411,0,0,1,.823.191,3.363,3.363,0,0,1,2.112,2.363,6.433,6.433,0,0,1,.1,1.573c0,4.125-.01,7.893-.014,11.283-.012,6.778-.023,12.04-.029,15.613a3.4,3.4,0,0,1-.649,2.234,3.284,3.284,0,0,1-1.321,1.061,3.4,3.4,0,0,1-1,.263C384.861,225.694,384.744,225.694,384.744,225.694Z",
    transform: "translate(-151.647 -191.01)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    transform: "translate(26.476 34.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M166.15,159.746v9.08h-1.388l-5.008-6.149v6.149h-1.673v-9.08h1.388l5.007,6.149v-6.149Z",
    transform: "translate(-158.081 -159.746)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(9.857 2.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M180.9,166.17v4.06h-1.531v-.844a2.453,2.453,0,0,1-2.179.934c-1.583,0-2.581-.869-2.581-2.075,0-1.155.779-2.063,2.88-2.063h1.79v-.1c0-.947-.571-1.5-1.725-1.5a3.425,3.425,0,0,0-2.1.688l-.635-1.181a4.868,4.868,0,0,1,2.932-.856C179.741,163.225,180.9,164.172,180.9,166.17Zm-1.621,1.894v-.8H177.6c-1.1,0-1.4.415-1.4.921,0,.584.493.96,1.323.96A1.765,1.765,0,0,0,179.274,168.063Z",
    transform: "translate(-174.604 -163.225)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    transform: "translate(18.223 2.076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M200.211,166.261v3.97h-1.621v-3.762c0-1.232-.571-1.829-1.556-1.829-1.064,0-1.8.7-1.8,2.075v3.516h-1.621v-3.762c0-1.232-.571-1.829-1.556-1.829-1.077,0-1.8.7-1.8,2.075v3.516h-1.621V163.3h1.543v.882a2.871,2.871,0,0,1,2.27-.96,2.594,2.594,0,0,1,2.334,1.154,3.233,3.233,0,0,1,2.594-1.154C199.043,163.225,200.211,164.172,200.211,166.261Z",
    transform: "translate(-188.628 -163.226)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(31.374 2.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M217.728,167.285h-5.435a2.1,2.1,0,0,0,2.244,1.66,2.484,2.484,0,0,0,1.881-.752l.869,1a3.89,3.89,0,0,1-6.616-2.426,3.445,3.445,0,0,1,3.581-3.541,3.378,3.378,0,0,1,3.5,3.58C217.754,166.935,217.741,167.13,217.728,167.285Zm-5.448-1.077h3.93a1.886,1.886,0,0,0-1.959-1.686A1.915,1.915,0,0,0,212.28,166.208Z",
    transform: "translate(-210.672 -163.225)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_644",
    "data-name": "Group 644",
    transform: "translate(40.373 67.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(0 0.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M185.849,220.375v.929h-4.473V215.34h4.354v.929h-3.246v1.551h2.88v.912h-2.88v1.644h3.365Z",
    transform: "translate(-181.376 -215.34)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    transform: "translate(5.604 1.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M195.251,219.618v2.608h-1.065v-2.471c0-.809-.4-1.2-1.082-1.2a1.209,1.209,0,0,0-1.27,1.372v2.3h-1.065v-4.549h1.014v.588a1.978,1.978,0,0,1,1.568-.639A1.777,1.777,0,0,1,195.251,219.618Z",
    transform: "translate(-190.769 -217.625)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629",
    transform: "translate(10.833 0.767)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M202.875,221.333a1.673,1.673,0,0,1-1.023.307,1.4,1.4,0,0,1-1.568-1.534v-2.189h-.75v-.853h.75v-1.039h1.065v1.039h1.218v.853H201.35v2.164c0,.443.221.682.631.682a.958.958,0,0,0,.6-.187Z",
    transform: "translate(-199.535 -216.025)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630",
    transform: "translate(14.521 1.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M210.352,220.292h-3.57a1.377,1.377,0,0,0,1.474,1.091,1.631,1.631,0,0,0,1.236-.494l.571.656a2.555,2.555,0,0,1-4.345-1.593,2.263,2.263,0,0,1,2.352-2.326,2.219,2.219,0,0,1,2.3,2.352C210.369,220.062,210.361,220.189,210.352,220.292Zm-3.578-.707h2.581a1.238,1.238,0,0,0-1.286-1.108A1.257,1.257,0,0,0,206.774,219.585Z",
    transform: "translate(-205.717 -217.626)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_631",
    "data-name": "Group 631",
    transform: "translate(20.194 1.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M217.859,217.624v1.014a1.331,1.331,0,0,0-.247-.026,1.24,1.24,0,0,0-1.321,1.406v2.207h-1.065v-4.549h1.014v.665A1.79,1.79,0,0,1,217.859,217.624Z",
    transform: "translate(-215.226 -217.624)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_632",
    "data-name": "Group 632",
    transform: "translate(25.278 1.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M228.852,217.71l-2.13,4.916a1.764,1.764,0,0,1-1.755,1.346,1.881,1.881,0,0,1-1.218-.418l.426-.784a1.153,1.153,0,0,0,.784.315c.375,0,.6-.179.8-.631l.076-.179-1.985-4.567h1.107l1.431,3.365,1.44-3.365h1.023Z",
    transform: "translate(-223.748 -217.709)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_633",
    "data-name": "Group 633",
    transform: "translate(30.541 1.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M232.57,219.95a2.426,2.426,0,1,1,2.42,2.334A2.29,2.29,0,0,1,232.57,219.95Zm3.775,0a1.352,1.352,0,1,0-1.355,1.423A1.325,1.325,0,0,0,236.345,219.95Z",
    transform: "translate(-232.57 -217.624)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_634",
    "data-name": "Group 634",
    transform: "translate(36.376 1.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M246.79,217.71v4.549h-1.014v-.579a1.858,1.858,0,0,1-1.465.639,1.8,1.8,0,0,1-1.96-2.011v-2.6h1.065v2.454c0,.826.392,1.218,1.065,1.218a1.2,1.2,0,0,0,1.244-1.371v-2.3h1.065Z",
    transform: "translate(-242.351 -217.709)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_635",
    "data-name": "Group 635",
    transform: "translate(42.209 1.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M254.763,217.624v1.014a1.331,1.331,0,0,0-.247-.026,1.24,1.24,0,0,0-1.321,1.406v2.207H252.13v-4.549h1.014v.665A1.791,1.791,0,0,1,254.763,217.624Z",
    transform: "translate(-252.13 -217.624)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_636",
    "data-name": "Group 636",
    transform: "translate(48.136 1.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M266.547,219.618v2.608h-1.065v-2.471c0-.809-.4-1.2-1.082-1.2a1.208,1.208,0,0,0-1.269,1.372v2.3h-1.065v-4.549h1.014v.588a1.978,1.978,0,0,1,1.568-.639A1.777,1.777,0,0,1,266.547,219.618Z",
    transform: "translate(-262.065 -217.625)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(53.647 1.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M275.435,219.559v2.667H274.43v-.554a1.613,1.613,0,0,1-1.431.613c-1.04,0-1.7-.571-1.7-1.363,0-.758.511-1.355,1.891-1.355h1.176V219.5c0-.622-.375-.988-1.133-.988a2.254,2.254,0,0,0-1.38.452l-.418-.776a3.2,3.2,0,0,1,1.926-.562C274.677,217.624,275.435,218.247,275.435,219.559ZM274.37,220.8v-.528h-1.1c-.724,0-.92.273-.92.6,0,.384.323.631.869.631A1.161,1.161,0,0,0,274.37,220.8Z",
    transform: "translate(-271.303 -217.625)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_638",
    "data-name": "Group 638",
    transform: "translate(59.139 1.721)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M288.119,219.618v2.608h-1.065v-2.471c0-.809-.375-1.2-1.023-1.2-.7,0-1.184.46-1.184,1.363v2.309h-1.065v-2.471c0-.809-.375-1.2-1.023-1.2-.707,0-1.184.46-1.184,1.363v2.309h-1.065v-4.549h1.014v.579a1.883,1.883,0,0,1,1.491-.631,1.7,1.7,0,0,1,1.534.758,2.123,2.123,0,0,1,1.7-.758A1.75,1.75,0,0,1,288.119,219.618Z",
    transform: "translate(-280.509 -217.625)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(67.777 1.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M299.623,220.292h-3.57a1.377,1.377,0,0,0,1.474,1.091,1.631,1.631,0,0,0,1.235-.494l.571.656a2.555,2.555,0,0,1-4.345-1.593,2.263,2.263,0,0,1,2.351-2.326,2.219,2.219,0,0,1,2.3,2.352C299.639,220.062,299.631,220.189,299.623,220.292Zm-3.579-.707h2.582a1.239,1.239,0,0,0-1.287-1.108A1.257,1.257,0,0,0,296.044,219.585Z",
    transform: "translate(-294.988 -217.626)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_640",
    "data-name": "Group 640",
    transform: "translate(75.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M312.917,218.454v2.608h-1.065v-2.471c0-.809-.4-1.2-1.082-1.2a1.208,1.208,0,0,0-1.269,1.372v2.3h-1.065V214.74H309.5v2.3a2.029,2.029,0,0,1,1.516-.579A1.777,1.777,0,0,1,312.917,218.454Z",
    transform: "translate(-308.436 -214.74)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_641",
    "data-name": "Group 641",
    transform: "translate(81.301 1.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M322.293,220.292h-3.57a1.377,1.377,0,0,0,1.474,1.091,1.631,1.631,0,0,0,1.236-.494l.571.656a2.555,2.555,0,0,1-4.345-1.593,2.263,2.263,0,0,1,2.352-2.326,2.219,2.219,0,0,1,2.3,2.352C322.31,220.062,322.3,220.189,322.293,220.292Zm-3.578-.707H321.3a1.238,1.238,0,0,0-1.286-1.108A1.257,1.257,0,0,0,318.715,219.585Z",
    transform: "translate(-317.658 -217.626)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_642",
    "data-name": "Group 642",
    transform: "translate(86.973 1.72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M329.8,217.624v1.014a1.331,1.331,0,0,0-.247-.026,1.24,1.24,0,0,0-1.321,1.406v2.207h-1.065v-4.549h1.014v.665A1.791,1.791,0,0,1,329.8,217.624Z",
    transform: "translate(-327.166 -217.624)",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_643",
    "data-name": "Group 643",
    transform: "translate(90.09 1.722)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M337.026,220.292h-3.57a1.377,1.377,0,0,0,1.474,1.091,1.631,1.631,0,0,0,1.235-.494l.571.656a2.555,2.555,0,0,1-4.345-1.593,2.263,2.263,0,0,1,2.352-2.326,2.219,2.219,0,0,1,2.3,2.352C337.043,220.062,337.035,220.189,337.026,220.292Zm-3.578-.707h2.581a1.238,1.238,0,0,0-1.286-1.108A1.257,1.257,0,0,0,333.448,219.585Z",
    transform: "translate(-332.391 -217.626)",
    fill: "#e0e0e0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_646",
    "data-name": "Group 646",
    transform: "translate(21.086 97.247)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_645",
    "data-name": "Group 645"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M212.524,289.831H161.678A12.631,12.631,0,0,1,149.047,277.2h0a12.631,12.631,0,0,1,12.631-12.631h50.846A12.631,12.631,0,0,1,225.156,277.2h0A12.631,12.631,0,0,1,212.524,289.831Z",
    transform: "translate(-149.047 -264.569)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_648",
    "data-name": "Group 648",
    transform: "translate(37.399 63.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_647",
    "data-name": "Group 647"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    width: 0.976,
    height: 16.107,
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_657",
    "data-name": "Group 657",
    transform: "translate(37.337 105.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_649",
    "data-name": "Group 649",
    transform: "translate(0 0.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M176.313,283.034a3.382,3.382,0,0,1,5.822-2.17l-.75.706a2.2,2.2,0,0,0-1.67-.733,2.2,2.2,0,1,0,0,4.394,2.173,2.173,0,0,0,1.67-.741l.75.714a3.382,3.382,0,0,1-5.822-2.17Z",
    transform: "translate(-176.298 -279.804)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M179.642,286.254a3.434,3.434,0,0,1-2.4-.912,3.284,3.284,0,0,1,0-4.636,3.448,3.448,0,0,1,2.4-.912,3.191,3.191,0,0,1,2.485,1.05l.01.011-.011.01-.761.715-.011-.011a2.184,2.184,0,0,0-1.659-.727,2.246,2.246,0,0,0-1.591.611,2.281,2.281,0,0,0,0,3.14,2.248,2.248,0,0,0,1.591.611,2.165,2.165,0,0,0,1.659-.736l.01-.012.011.011.76.724-.009.011A3.2,3.2,0,0,1,179.642,286.254Zm.009-6.429a3.415,3.415,0,0,0-2.384.9,3.253,3.253,0,0,0,0,4.594,3.4,3.4,0,0,0,2.376.9A3.173,3.173,0,0,0,182.1,285.2l-.729-.694a2.193,2.193,0,0,1-1.67.734,2.212,2.212,0,1,1,0-4.424,2.21,2.21,0,0,1,1.67.727l.729-.685A3.16,3.16,0,0,0,179.651,279.824Z",
    transform: "translate(-176.288 -279.794)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(6.263 2.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M186.811,284.8a2.542,2.542,0,1,1,2.536,2.447A2.4,2.4,0,0,1,186.811,284.8Zm3.956,0a1.417,1.417,0,1,0-1.42,1.491A1.389,1.389,0,0,0,190.767,284.8Z",
    transform: "translate(-186.796 -282.35)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M189.337,287.255a2.459,2.459,0,1,1,0-4.915,2.632,2.632,0,0,1,1.839.687,2.527,2.527,0,0,1,0,3.535A2.628,2.628,0,0,1,189.337,287.255Zm0-4.885a2.429,2.429,0,1,0,0,4.854,2.592,2.592,0,0,0,1.818-.684,2.5,2.5,0,0,0,0-3.492A2.607,2.607,0,0,0,189.337,282.37Zm0,3.929a1.508,1.508,0,1,1,1.435-1.506A1.4,1.4,0,0,1,189.337,286.3Zm0-2.982a1.478,1.478,0,1,0,1.4,1.476A1.375,1.375,0,0,0,189.337,283.317Z",
    transform: "translate(-186.786 -282.34)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_651",
    "data-name": "Group 651",
    transform: "translate(12.417 2.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M201.826,284.454v2.732H200.71V284.6c0-.848-.42-1.259-1.134-1.259a1.266,1.266,0,0,0-1.33,1.437v2.411h-1.116v-4.768h1.063v.616a2.074,2.074,0,0,1,1.643-.669A1.864,1.864,0,0,1,201.826,284.454Z",
    transform: "translate(-197.113 -282.349)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M201.829,287.191h-1.146v-2.6c0-.814-.387-1.244-1.119-1.244a1.249,1.249,0,0,0-1.316,1.422v2.426H197.1v-4.8h1.092v.591a2.114,2.114,0,0,1,1.628-.644,2.014,2.014,0,0,1,1.435.51,2.123,2.123,0,0,1,.572,1.595v2.748Zm-1.116-.03H201.8v-2.717a1.845,1.845,0,0,0-1.976-2.074,2.068,2.068,0,0,0-1.632.663l-.026.032v-.641h-1.033v4.738h1.086v-2.4a1.288,1.288,0,0,1,1.345-1.453c.752,0,1.149.441,1.149,1.274v2.575Z",
    transform: "translate(-197.102 -282.339)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_652",
    "data-name": "Group 652",
    transform: "translate(17.904 1.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M209.824,286.251a1.755,1.755,0,0,1-1.071.322,1.465,1.465,0,0,1-1.643-1.607V282.67h-.786v-.893h.786v-1.089h1.116v1.089H209.5v.893h-1.277v2.268c0,.464.232.714.661.714a1,1,0,0,0,.625-.2Z",
    transform: "translate(-206.309 -280.673)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M208.743,286.578a1.48,1.48,0,0,1-1.658-1.623v-2.28H206.3v-.923h.786v-1.089h1.146v1.089h1.277v.923h-1.277v2.253c0,.458.223.7.646.7a.979.979,0,0,0,.616-.193l.016-.013.008.019.316.8-.008.007A1.762,1.762,0,0,1,208.743,286.578Zm-2.414-3.933h.786v2.31a1.452,1.452,0,0,0,1.629,1.592,1.737,1.737,0,0,0,1.054-.311l-.3-.766a1.014,1.014,0,0,1-.618.187c-.435,0-.676-.26-.676-.73v-2.283h1.277v-.863H208.2v-1.089h-1.086v1.089h-.786v.863Z",
    transform: "translate(-206.299 -280.663)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_653",
    "data-name": "Group 653",
    transform: "translate(22.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M213.481,279.561a.68.68,0,0,1,.714-.669.665.665,0,0,1,.715.642.715.715,0,0,1-1.429.027Zm.152,1.456h1.116v4.768h-1.116Z",
    transform: "translate(-213.466 -278.876)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M214.754,285.79h-1.146v-4.8h1.146Zm-1.117-.03h1.086v-4.738h-1.086Zm.548-5.524a.686.686,0,1,1,0-1.37.682.682,0,0,1,.73.658A.7.7,0,0,1,214.185,280.236Zm0-1.339a.656.656,0,1,0,.7.628A.652.652,0,0,0,214.185,278.9Z",
    transform: "translate(-213.456 -278.866)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_654",
    "data-name": "Group 654",
    transform: "translate(24.907 2.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M222.76,284.454v2.732h-1.116V284.6c0-.848-.42-1.259-1.134-1.259a1.266,1.266,0,0,0-1.331,1.437v2.411h-1.116v-4.768h1.062v.616a2.074,2.074,0,0,1,1.643-.669A1.864,1.864,0,0,1,222.76,284.454Z",
    transform: "translate(-218.048 -282.349)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M222.765,287.191h-1.146v-2.6c0-.814-.387-1.244-1.119-1.244a1.249,1.249,0,0,0-1.316,1.422v2.426h-1.146v-4.8h1.092v.591a2.114,2.114,0,0,1,1.629-.644,2.014,2.014,0,0,1,1.435.51,2.123,2.123,0,0,1,.572,1.595Zm-1.117-.03h1.086v-2.717a1.845,1.845,0,0,0-1.976-2.074,2.068,2.068,0,0,0-1.632.663l-.026.032v-.641h-1.033v4.738h1.086v-2.4a1.288,1.288,0,0,1,1.345-1.453c.752,0,1.149.441,1.149,1.274v2.575Z",
    transform: "translate(-218.038 -282.339)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_655",
    "data-name": "Group 655",
    transform: "translate(30.99 2.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M232.914,282.454v4.768h-1.062v-.607a1.949,1.949,0,0,1-1.536.669,1.886,1.886,0,0,1-2.054-2.107v-2.723h1.116v2.572c0,.866.41,1.277,1.116,1.277a1.257,1.257,0,0,0,1.3-1.438v-2.411h1.116Z",
    transform: "translate(-228.246 -282.439)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M230.3,287.29a2.077,2.077,0,0,1-1.5-.519,2.133,2.133,0,0,1-.573-1.6v-2.739h1.146v2.587c0,.826.381,1.262,1.1,1.262.819,0,1.289-.518,1.289-1.423v-2.426h1.146v4.8h-1.092v-.582A1.979,1.979,0,0,1,230.3,287.29Zm-2.039-4.831v2.708a2.1,2.1,0,0,0,.564,1.582,2.049,2.049,0,0,0,1.475.509,1.938,1.938,0,0,0,1.524-.663l.026-.033v.634h1.033v-4.738H231.8v2.4a1.278,1.278,0,0,1-1.318,1.453c-.74,0-1.131-.447-1.131-1.292V282.46h-1.086Z",
    transform: "translate(-228.236 -282.429)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_656",
    "data-name": "Group 656",
    transform: "translate(36.717 2.072)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M242.719,285.159h-3.742a1.444,1.444,0,0,0,1.545,1.143,1.708,1.708,0,0,0,1.295-.518l.6.688a2.678,2.678,0,0,1-4.554-1.67,2.371,2.371,0,0,1,2.464-2.438,2.326,2.326,0,0,1,2.411,2.464C242.736,284.918,242.728,285.052,242.719,285.159Zm-3.751-.742h2.706a1.3,1.3,0,0,0-1.348-1.16A1.318,1.318,0,0,0,238.968,284.418Z",
    transform: "translate(-237.845 -282.35)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M240.484,287.255a2.736,2.736,0,0,1-1.927-.7,2.473,2.473,0,0,1,1.757-4.22,2.347,2.347,0,0,1,2.426,2.479c0,.109-.013.268-.018.332v.014h-3.737a1.434,1.434,0,0,0,1.527,1.113,1.7,1.7,0,0,0,1.284-.514l.011-.012.011.013.607.7-.008.01A2.422,2.422,0,0,1,240.484,287.255Zm-.169-4.885a2.443,2.443,0,0,0-1.737,4.168,2.707,2.707,0,0,0,1.907.686,2.4,2.4,0,0,0,1.9-.761l-.579-.666a1.731,1.731,0,0,1-1.294.511,1.46,1.46,0,0,1-1.559-1.155l0-.018H242.7c.006-.07.017-.215.017-.316A2.32,2.32,0,0,0,240.315,282.37Zm1.365,2.053h-2.74l0-.017a1.384,1.384,0,0,1,2.735,0Zm-2.7-.03h2.671a1.354,1.354,0,0,0-2.671,0Z",
    transform: "translate(-237.835 -282.34)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_659",
    "data-name": "Group 659",
    transform: "translate(7.789 5.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_658",
    "data-name": "Group 658"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 2.838,
    cy: 2.838,
    r: 2.838,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_661",
    "data-name": "Group 661",
    transform: "translate(18.248 5.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_660",
    "data-name": "Group 660"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.838,
    cy: 2.838,
    r: 2.838,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_663",
    "data-name": "Group 663",
    transform: "translate(28.707 5.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    "data-name": "Group 662"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 2.838,
    cy: 2.838,
    r: 2.838,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(45.58 163.803)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_721",
    "data-name": "Group 721",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669",
    transform: "translate(36.324 48.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_666",
    "data-name": "Group 666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_665",
    "data-name": "Group 665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M114.807,331.634a19.615,19.615,0,0,1,12.169-1.479c2.208.365,4.509,1.025,6.012,2.683s1.787,4.576.062,6a5.757,5.757,0,0,1-3.791.962c-3.217-.038-6.786-.6-9.356,1.332-1.466,1.1-2.442,2.94-4.2,3.483a4.144,4.144,0,0,1-4.56-2.029,7.086,7.086,0,0,1-.516-5.227A7.979,7.979,0,0,1,114.807,331.634Z",
    transform: "translate(-110.369 -329.812)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(30.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M102.147,282.721c2.263,3.232,6.662,2.162,8.7.189s2.9-4.833,3.686-7.56c1.793-6.231,3.6-12.768,2.268-19.113a10.617,10.617,0,0,0-2.441-5.2,5.548,5.548,0,0,0-5.257-1.749c-2.218.586-3.6,2.759-4.593,4.825a45.557,45.557,0,0,0-4.5,19.552c-.01,3.149.361,6.452,2.137,9.052",
    transform: "translate(-100.01 -249.149)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679",
    transform: "translate(0 10.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M75.547,294.394c2.457-2.917,2.924-7.171,1.83-10.824a20.864,20.864,0,0,0-6.411-9.3,34.515,34.515,0,0,0-11.48-6.773,12.245,12.245,0,0,0-5.163-.877,5.417,5.417,0,0,0-4.333,2.621c-1.208,2.3-.05,5.1,1.2,7.38a87.46,87.46,0,0,0,7.54,11.482c2.26,2.914,4.849,5.788,8.293,7.1s7.022,1.162,8.848-1.227",
    transform: "translate(-49.481 -266.585)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(32.087 52.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M103.308,367.062a7.062,7.062,0,0,0,.2-1.469c.1-1.069.235-2.411.39-4.009a57.822,57.822,0,0,1,.9-5.88,45.382,45.382,0,0,1,2.137-6.94,25.609,25.609,0,0,1,3.544-6.279,13.232,13.232,0,0,1,4.48-3.724,12.541,12.541,0,0,1,3.773-1.175,7.034,7.034,0,0,0,1.463-.212,6.911,6.911,0,0,0-1.488-.023,11.443,11.443,0,0,0-3.934,1.024,13.207,13.207,0,0,0-4.726,3.757,24.975,24.975,0,0,0-3.673,6.406,42.431,42.431,0,0,0-2.122,7.053,49.63,49.63,0,0,0-.781,5.954c-.127,1.7-.175,3.081-.2,4.033A6.913,6.913,0,0,0,103.308,367.062Z",
    transform: "translate(-103.267 -337.337)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691",
    transform: "translate(32.085 12.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M103.583,337.183a2.9,2.9,0,0,0,.039-.682c0-.512,0-1.157-.005-1.949,0-1.691,0-4.139.087-7.162.15-6.045.671-12.551,1.676-21.724.952-8.625,2.23-18.663,3.578-25.189.289-1.484.58-2.82.855-3.989s.484-2.183.7-3c.185-.77.336-1.4.455-1.895a2.885,2.885,0,0,0,.119-.672,2.835,2.835,0,0,0-.237.639l-.566,1.868c-.251.81-.508,1.814-.8,2.982s-.628,2.5-.944,3.979a221.179,221.179,0,0,0-3.762,23.373c-1.008,9.192-1.461,17.561-1.5,23.622-.036,3.03.029,5.483.106,7.175.048.792.088,1.436.119,1.948A2.924,2.924,0,0,0,103.583,337.183Z",
    transform: "translate(-103.264 -270.921)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(10.852 17.924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M89.264,324.379a12.853,12.853,0,0,0-.014-2.036c-.075-1.308-.255-3.2-.623-5.516a72.807,72.807,0,0,0-1.794-8.037,65.88,65.88,0,0,0-3.36-9.51,50.662,50.662,0,0,0-9.87-15.368,25.009,25.009,0,0,0-2.322-2.158c-.356-.3-.671-.6-.992-.839l-.9-.621a12.93,12.93,0,0,0-1.714-1.1,60.724,60.724,0,0,1,5.618,5.012,53.38,53.38,0,0,1,9.623,15.313,75.108,75.108,0,0,1,3.38,9.422A81.79,81.79,0,0,1,88.2,316.9c.421,2.293.664,4.165.811,5.462A13.133,13.133,0,0,0,89.264,324.379Z",
    transform: "translate(-67.671 -279.194)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(16.843 91.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M77.714,402.667l4.813,24.553h22.724l4.166-24.553Z",
    transform: "translate(-77.714 -402.667)",
    fill: "#ff725e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(14.093 82.849)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 37.849,
    height: 8.734,
    fill: "#ff725e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(17.916 95.712)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M108.98,412.7a.91.91,0,0,1-.128.2l-.408.564-1.592,2.122-.071.094-.069-.1-3.912-5.635h.225l-3.851,5.68-.121.178-.135-.168-4.567-5.66.263,0-.251.329-4.083,5.333-.136.178-.126-.185-3.853-5.678.224.011L81.645,415.6l-.084.1-.064-.113-1.485-2.6-.381-.692a1.1,1.1,0,0,1-.116-.247,1.1,1.1,0,0,1,.159.22l.422.666,1.559,2.553-.149-.013,4.669-5.7.118-.144.107.155,3.887,5.652-.262-.007,4.074-5.34.251-.329.13-.17.134.166,4.554,5.671-.256.01,3.889-5.651.114-.165.112.165,3.829,5.7-.139,0,1.656-2.068.443-.534A.967.967,0,0,1,108.98,412.7Z",
    transform: "translate(-79.513 -409.588)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_720",
    "data-name": "Group 720",
    transform: "translate(17.08 91.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_719",
    "data-name": "Group 719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M109.973,402.3c0,.1-7.133.177-15.93.177s-15.932-.079-15.932-.177,7.131-.177,15.932-.177S109.973,402.2,109.973,402.3Z",
    transform: "translate(-78.111 -402.124)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(258.37 94.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_825",
    "data-name": "Group 825",
    transform: "translate(36.068 59.178)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_723",
    "data-name": "Group 723",
    transform: "translate(11.241 20.431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_722",
    "data-name": "Group 722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M485.477,272.013l4.62,4.958s19.323,32.4,22.083,34.484,7.37,4.478,10.136,4.109,10.1-5.348,10.1-5.348l-6.408-19.689-7.292-2L499.036,265.72Z",
    transform: "translate(-485.477 -265.72)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_824",
    "data-name": "Group 824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_823",
    "data-name": "Group 823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_822",
    "data-name": "Group 822"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_733",
    "data-name": "Group 733"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_732",
    "data-name": "Group 732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_731",
    "data-name": "Group 731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_730",
    "data-name": "Group 730"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_729",
    "data-name": "Group 729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_728",
    "data-name": "Group 728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_727",
    "data-name": "Group 727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_726",
    "data-name": "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_725",
    "data-name": "Group 725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_724",
    "data-name": "Group 724"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M481.572,262.1c-1.641-1.976-5.873-6.038-5.873-6.038l-1.782-1.9a2.963,2.963,0,0,0-.2.488,1.975,1.975,0,0,1-.453.874,1.547,1.547,0,0,1-1.763-.02,3.724,3.724,0,0,1-.131-6.422,2.8,2.8,0,0,1,.49-.962c1.514-1.942,5.059-1.682,5.059-1.682l-.53-.754s-2.417-1.506-6.437,1.043a2.909,2.909,0,0,1-2.025.441,1.472,1.472,0,0,1-1.081-.655c-.586-1-.033-1.671,2.455-3.3s5.423-2.369,7.288-1.678a19.639,19.639,0,0,1,2.548,1.083s-4.39-7.086-4.65-7.545c-.752-1.33-.787-2.781.05-3.371.537-.378,1.493-.458,2.415,1.064.8,1.317,10.695,13.758,10.695,13.758l4.055,5.762Z",
    transform: "translate(-466.634 -231.473)",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_755",
    "data-name": "Group 755",
    transform: "translate(10.376 15.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_743",
    "data-name": "Group 743",
    transform: "translate(0.249 0.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_740",
    "data-name": "Group 740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_739",
    "data-name": "Group 739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_738",
    "data-name": "Group 738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_737",
    "data-name": "Group 737"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_735",
    "data-name": "Group 735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_734",
    "data-name": "Group 734"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M497.423,263.05a2.171,2.171,0,0,1-2.525.162c-.8-.415-1.445-1.091-2.218-1.564-2.311-1.412-5.47-.835-7.711-2.356-.313-.212-.631-.572-.49-.922.131-.324.554-.388.9-.4l8.963-.369",
    transform: "translate(-484.445 -257.599)",
    fill: "#ffbe9d"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_754",
    "data-name": "Group 754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_753",
    "data-name": "Group 753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_752",
    "data-name": "Group 752"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_751",
    "data-name": "Group 751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_750",
    "data-name": "Group 750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_749",
    "data-name": "Group 749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_748",
    "data-name": "Group 748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_747",
    "data-name": "Group 747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_746",
    "data-name": "Group 746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_745",
    "data-name": "Group 745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_744",
    "data-name": "Group 744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_234",
    "data-name": "Path 234",
    d: "M494.178,257.558a3.592,3.592,0,0,0-.974-.06c-.625,0-1.53,0-2.646.027l-3.922.107-1.133.038a1.779,1.779,0,0,0-1.3.359.757.757,0,0,0-.092.844,1.552,1.552,0,0,0,.487.549,5.879,5.879,0,0,0,1.169.619,34.322,34.322,0,0,0,4.723,1.023,6.764,6.764,0,0,1,1.891.716c.543.32,1.006.722,1.472,1.048a3.156,3.156,0,0,0,2.574.725c.653-.171.846-.544.824-.544a2.628,2.628,0,0,1-.863.348,3.058,3.058,0,0,1-2.321-.821c-.436-.332-.887-.754-1.467-1.12a6.954,6.954,0,0,0-2-.811,40,40,0,0,1-4.647-1.04,5.488,5.488,0,0,1-1.058-.555c-.3-.214-.468-.521-.317-.653.142-.169.554-.187.938-.2l1.133-.056,3.918-.217c1.115-.069,2.017-.134,2.64-.19A3.59,3.59,0,0,0,494.178,257.558Z",
    transform: "translate(-484.027 -257.497)",
    fill: "#eb996e"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_766",
    "data-name": "Group 766",
    transform: "translate(0.01 13.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_765",
    "data-name": "Group 765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_764",
    "data-name": "Group 764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_763",
    "data-name": "Group 763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_762",
    "data-name": "Group 762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_761",
    "data-name": "Group 761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_760",
    "data-name": "Group 760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_759",
    "data-name": "Group 759"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_758",
    "data-name": "Group 758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_757",
    "data-name": "Group 757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_756",
    "data-name": "Group 756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M477.046,255.444a3.7,3.7,0,0,0-1.3-1.086,2.858,2.858,0,0,0-1.784-.144,7.317,7.317,0,0,0-2.092.893,11.669,11.669,0,0,1-2.117,1.048,3.759,3.759,0,0,1-1.95.163,1.469,1.469,0,0,1-1.042-.808.863.863,0,0,1-.1-.472c.031-.008.069.16.217.412a1.386,1.386,0,0,0,.977.64,3.732,3.732,0,0,0,1.8-.223,12.939,12.939,0,0,0,2.051-1.046,7.106,7.106,0,0,1,2.2-.9,3,3,0,0,1,1.944.232,2.663,2.663,0,0,1,1,.862C477.015,255.268,477.063,255.436,477.046,255.444Z",
    transform: "translate(-466.651 -253.851)",
    fill: "#eb996e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_777",
    "data-name": "Group 777",
    transform: "translate(7.57 3.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_775",
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_774",
    "data-name": "Group 774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_773",
    "data-name": "Group 773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_772",
    "data-name": "Group 772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_771",
    "data-name": "Group 771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_770",
    "data-name": "Group 770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_769",
    "data-name": "Group 769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_768",
    "data-name": "Group 768"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_767",
    "data-name": "Group 767"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_236",
    "data-name": "Path 236",
    d: "M479.327,236.644a9.381,9.381,0,0,1,.882,1.4l2.037,3.429,2.088,3.4a9.4,9.4,0,0,1,.832,1.434,7.4,7.4,0,0,1-1.026-1.3c-.591-.836-1.367-2.02-2.176-3.357s-1.493-2.575-1.959-3.488A7.386,7.386,0,0,1,479.327,236.644Z",
    transform: "translate(-479.323 -236.643)",
    fill: "#eb996e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_788",
    "data-name": "Group 788",
    transform: "translate(4.557 17.486)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_784",
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_783",
    "data-name": "Group 783"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_779",
    "data-name": "Group 779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_778",
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_237",
    "data-name": "Path 237",
    d: "M479.491,260.824a2.037,2.037,0,0,1-.511.091,1.536,1.536,0,0,0-1.126.613.824.824,0,0,0-.008.816,4.372,4.372,0,0,0,.627.879,1.86,1.86,0,0,1,.509,1.217,1.581,1.581,0,0,1-.742,1.223,1.794,1.794,0,0,1-1.407.2,2.246,2.246,0,0,1-1.129-.67,7.291,7.291,0,0,1-1.08-1.839,4.3,4.3,0,0,1-.351-1.392.959.959,0,0,1,.079-.523c.03.005,0,.189.049.51a5.077,5.077,0,0,0,.437,1.31,7.8,7.8,0,0,0,1.093,1.729,1.777,1.777,0,0,0,2.132.4,1.27,1.27,0,0,0,.6-.96,1.585,1.585,0,0,0-.426-1.015,4.387,4.387,0,0,1-.639-.959,1.069,1.069,0,0,1,.064-1.049,1.608,1.608,0,0,1,1.309-.615A1.337,1.337,0,0,1,479.491,260.824Z",
    transform: "translate(-474.272 -260.785)",
    fill: "#eb996e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_799",
    "data-name": "Group 799",
    transform: "translate(2.677 17.785)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_798",
    "data-name": "Group 798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_797",
    "data-name": "Group 797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_796",
    "data-name": "Group 796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_792",
    "data-name": "Group 792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_791",
    "data-name": "Group 791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_790",
    "data-name": "Group 790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_789",
    "data-name": "Group 789"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_238",
    "data-name": "Path 238",
    d: "M475.546,265.773c.012-.011.143.117.205.426a1.442,1.442,0,0,1-.382,1.234,1.923,1.923,0,0,1-1.852.467,3.146,3.146,0,0,1-1.836-1.45,3.808,3.808,0,0,1-.548-2.271,3.636,3.636,0,0,1,.65-1.791,3.44,3.44,0,0,1,.909-.9c.254-.165.412-.22.421-.2a5.977,5.977,0,0,0-1.136,1.229,3.594,3.594,0,0,0-.542,1.684,3.631,3.631,0,0,0,.526,2.078,2.922,2.922,0,0,0,1.631,1.328,1.708,1.708,0,0,0,1.61-.339,1.369,1.369,0,0,0,.418-1.052C475.607,265.933,475.52,265.787,475.546,265.773Z",
    transform: "translate(-471.121 -261.285)",
    fill: "#eb996e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810",
    transform: "translate(14.899 18.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_807",
    "data-name": "Group 807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_806",
    "data-name": "Group 806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_805",
    "data-name": "Group 805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_804",
    "data-name": "Group 804"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_803",
    "data-name": "Group 803"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_802",
    "data-name": "Group 802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_801",
    "data-name": "Group 801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_800",
    "data-name": "Group 800"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M491.608,268.334c-.017-.024.207-.232.685-.4a3.121,3.121,0,0,1,2.028,0l-.2.215a9.175,9.175,0,0,1-.42-1.045,7.116,7.116,0,0,1-.341-3.864,17.977,17.977,0,0,0,.654,3.76c.121.362.256.705.394,1.016l.152.344-.349-.129a3.277,3.277,0,0,0-1.865-.1C491.886,268.23,491.63,268.372,491.608,268.334Z",
    transform: "translate(-491.607 -263.232)",
    fill: "#eb996e"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_821",
    "data-name": "Group 821",
    transform: "translate(5.922 12.015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_820",
    "data-name": "Group 820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_819",
    "data-name": "Group 819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_818",
    "data-name": "Group 818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_817",
    "data-name": "Group 817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_816",
    "data-name": "Group 816"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_815",
    "data-name": "Group 815"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_814",
    "data-name": "Group 814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_813",
    "data-name": "Group 813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_812",
    "data-name": "Group 812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_811",
    "data-name": "Group 811"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M478.031,251.613c.087-.008.123.67-.339,1.318s-1.108.845-1.129.76c-.041-.087.465-.381.86-.95S477.936,251.6,478.031,251.613Z",
    transform: "translate(-476.56 -251.613)",
    fill: "#eb996e"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_851",
    "data-name": "Group 851",
    transform: "translate(0 184.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_827",
    "data-name": "Group 827"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_826",
    "data-name": "Group 826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M441.973,442.012a47.627,47.627,0,0,1-14.72.639c-6.51-.976-21.084.034-21.079,8.613.006,9.569,19.441,7.2,27.024,5.688s15.134-2.891,15.134-2.891Z",
    transform: "translate(-406.174 -442.012)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830",
    transform: "translate(16.808 5.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_829",
    "data-name": "Group 829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_828",
    "data-name": "Group 828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M435.885,458a32.149,32.149,0,0,1-1.515-6.742A32.047,32.047,0,0,1,435.885,458Z",
    transform: "translate(-434.348 -451.259)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_833",
    "data-name": "Group 833",
    transform: "translate(20.018 5.505)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_832",
    "data-name": "Group 832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M440.708,458.12a32.476,32.476,0,0,1-.944-6.88,32.489,32.489,0,0,1,.944,6.88Z",
    transform: "translate(-439.73 -451.24)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_836",
    "data-name": "Group 836",
    transform: "translate(22.788 5.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_835",
    "data-name": "Group 835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    "data-name": "Group 834"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M445.143,457.03a24.7,24.7,0,0,1-.725-6.012,24.7,24.7,0,0,1,.725,6.012Z",
    transform: "translate(-444.373 -451.018)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839",
    transform: "translate(26.245 5.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M451.5,455.83a10.284,10.284,0,0,1-1.286-5.3,762.314,762.314,0,0,1,1.286,5.3Z",
    transform: "translate(-450.167 -450.533)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842",
    transform: "translate(28.433 0.88)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M453.846,449.49a3.34,3.34,0,0,1,1.017-.067,8.612,8.612,0,0,1,2.73.534,3.077,3.077,0,0,1,.841.453,1.277,1.277,0,0,1,.526.948,1.438,1.438,0,0,1-1.761,1.28,3.619,3.619,0,0,1-2.03-1.445,6.183,6.183,0,0,1-1.148-2.392,6.077,6.077,0,0,1,.856-4.955.99.99,0,0,1,.577-.347.781.781,0,0,1,.647.2,1.741,1.741,0,0,1,.487,1.044,5.306,5.306,0,0,1-.1,1.945,5.412,5.412,0,0,1-1.312,2.454,4.222,4.222,0,0,1-.568.5c-.142.1-.22.146-.227.136-.021-.027.271-.244.687-.736a5.587,5.587,0,0,0,1.163-2.415,5.156,5.156,0,0,0,.054-1.843,1.454,1.454,0,0,0-.4-.843.5.5,0,0,0-.75.126,5.834,5.834,0,0,0-.752,4.641,5.9,5.9,0,0,0,1.074,2.255,3.327,3.327,0,0,0,1.8,1.332,1.124,1.124,0,0,0,1.391-.935.986.986,0,0,0-.4-.733,2.846,2.846,0,0,0-.754-.43,9.5,9.5,0,0,0-2.645-.635C454.208,449.508,453.847,449.52,453.846,449.49Z",
    transform: "translate(-453.834 -443.487)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845",
    transform: "translate(1.221 0.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M448.388,452.912a.854.854,0,0,1-.2.062l-.583.145-2.254.514c-1.962.431-4.807,1.037-8.342,1.72s-7.758,1.453-12.493,2.1a33.752,33.752,0,0,1-7.505.374,16.155,16.155,0,0,1-3.932-.752,10.831,10.831,0,0,1-1.887-.838,5.85,5.85,0,0,1-1.657-1.335l.029.032a3.954,3.954,0,0,1-.676-.812,5.06,5.06,0,0,1-.4-4.187,6.694,6.694,0,0,1,2.494-3.259,12.645,12.645,0,0,1,3.544-1.756c.62-.176,1.224-.389,1.839-.528.618-.123,1.221-.287,1.83-.371,4.874-.77,9.308-.378,12.991-.377,1.847.034,3.515-.016,4.977-.106a33.244,33.244,0,0,0,3.724-.471l1.341-.282.966-.275.6-.164A.919.919,0,0,1,443,442.3a.857.857,0,0,1-.2.08l-.586.2-.96.311-1.34.317a31.327,31.327,0,0,1-3.736.536c-1.468.11-3.144.178-4.994.161-3.692.031-8.122-.328-12.932.452-.6.085-1.195.25-1.8.373-.606.139-1.2.351-1.808.525a12.337,12.337,0,0,0-3.441,1.713,6.341,6.341,0,0,0-2.358,3.079,4.7,4.7,0,0,0,.358,3.875,3.578,3.578,0,0,0,.609.733l.012.012.017.02a5.568,5.568,0,0,0,1.537,1.226,10.508,10.508,0,0,0,1.819.81,15.861,15.861,0,0,0,3.844.74,33.713,33.713,0,0,0,7.431-.35c4.725-.624,8.95-1.373,12.489-2.016s6.391-1.216,8.361-1.6l2.268-.446.591-.11A.853.853,0,0,1,448.388,452.912Z",
    transform: "translate(-408.221 -442.299)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_848",
    "data-name": "Group 848",
    transform: "translate(11.137 1.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_847",
    "data-name": "Group 847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M426.656,458.706a12.8,12.8,0,0,1-.189-1.988c-.088-1.227-.234-2.918-.482-4.776s-.554-3.528-.792-4.735a12.734,12.734,0,0,1-.341-1.967,9.131,9.131,0,0,1,.6,1.91,43.766,43.766,0,0,1,1.28,9.556A9.1,9.1,0,0,1,426.656,458.706Z",
    transform: "translate(-424.843 -445.241)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_850",
    "data-name": "Group 850",
    transform: "translate(33.405)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_849",
    "data-name": "Group 849"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M462.17,442.426,467.1,454.77l3.825-.708L463.6,442.012Z",
    transform: "translate(-462.17 -442.012)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_867",
    "data-name": "Group 867",
    transform: "translate(78.797 59.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_866",
    "data-name": "Group 866"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_856",
    "data-name": "Group 856",
    transform: "translate(4.605)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_855",
    "data-name": "Group 855"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_854",
    "data-name": "Group 854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_853",
    "data-name": "Group 853"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_852",
    "data-name": "Group 852"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M545.977,328.844l11.576-25.825-6.7-22.159a28.99,28.99,0,0,1,1.338-20.346l11.3-21.9,10.089-3.6,23.674-3.156a75.321,75.321,0,0,1,8.619,2.541,25.872,25.872,0,0,1,14.062,11.305h0L600.8,301.491s12.971,28.383,11.345,41.394Z",
    transform: "translate(-545.977 -231.861)",
    fill: "#ff725e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_860",
    "data-name": "Group 860",
    transform: "translate(0 6.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_859",
    "data-name": "Group 859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_858",
    "data-name": "Group 858"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_857",
    "data-name": "Group 857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M562.268,242.214s-13.242,2.932-18.071,21l-5.94,19.242,10.868.669Z",
    transform: "translate(-538.258 -242.214)",
    fill: "#ff725e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_865",
    "data-name": "Group 865",
    transform: "translate(8.871 20.54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_864",
    "data-name": "Group 864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_863",
    "data-name": "Group 863"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_862",
    "data-name": "Group 862"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M554.14,293.466a1.147,1.147,0,0,1-.12-.268c-.066-.181-.178-.443-.286-.793a14.42,14.42,0,0,1-.561-3.051,20.337,20.337,0,0,1,2.037-9.947,29.085,29.085,0,0,1,1.4-2.562c.477-.808.934-1.589,1.343-2.346a24.848,24.848,0,0,0,1.82-4.18c.408-1.237.7-2.251.918-2.949l.251-.8a1.17,1.17,0,0,1,.106-.275,1.2,1.2,0,0,1-.052.29l-.2.817c-.184.707-.449,1.73-.836,2.98a23.689,23.689,0,0,1-1.782,4.24c-.406.765-.86,1.551-1.335,2.362s-.955,1.647-1.383,2.543a20.835,20.835,0,0,0-2.092,9.817,16,16,0,0,0,.469,3.034C554.036,293.073,554.161,293.458,554.14,293.466Z",
    transform: "translate(-553.128 -266.292)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_897",
    "data-name": "Group 897",
    transform: "translate(0.205 130.831)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(28.082 15.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_870",
    "data-name": "Group 870"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_869",
    "data-name": "Group 869"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_868",
    "data-name": "Group 868"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M481.114,398.3c-.061.082-6.273-4.446-13.873-10.114s-13.713-10.331-13.651-10.414,6.272,4.446,13.874,10.115S481.176,398.222,481.114,398.3Z",
    transform: "translate(-453.59 -377.775)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_887",
    "data-name": "Group 887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_874",
    "data-name": "Group 874"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_873",
    "data-name": "Group 873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_872",
    "data-name": "Group 872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M554.815,388.591l-18.792-15.447h0a23.241,23.241,0,0,0-24.969-18.989h0a23.234,23.234,0,0,0-12.628,5.175l-10.894,8.538c-16.933-4.618-42.676-11.836-55.9-15.555a19.562,19.562,0,0,0-15.927,2.41l-.248.16a19.566,19.566,0,0,0-8.425,20.86h0a19.554,19.554,0,0,0,8.832,12.247c6.682,4.094,17.031,10.408,25.93,15.73l-1.181.925,7.863,12.935,16.19-4.991c10.943-1.561,34.048-4.567,34.048-4.567l-6.607-3.894,1.512-.467c12.583,10.72,27.969,15.656,47.018,7.34C550.035,406.593,555.9,396,554.815,388.591Z",
    transform: "translate(-406.518 -351.581)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_878",
    "data-name": "Group 878",
    transform: "translate(41.952 35.285)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_877",
    "data-name": "Group 877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_876",
    "data-name": "Group 876"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_875",
    "data-name": "Group 875"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M550.987,410.729a.886.886,0,0,1-.153.143l-.472.389-1.841,1.469-1.337,1.055c-.488.387-1.063.746-1.657,1.165l-1.921,1.317c-.342.231-.687.477-1.052.714l-1.148.691c-1.571.938-3.267,2.012-5.189,2.983-.953.5-1.926,1.042-2.953,1.55l-3.2,1.515c-4.4,2.006-9.332,4.024-14.617,5.822-10.56,3.639-20.324,6.259-27.317,8.379-1.753.515-3.334,1-4.718,1.437s-2.581.8-3.548,1.126l-2.238.727-.585.18a.877.877,0,0,1-.2.05.887.887,0,0,1,.191-.085l.573-.215,2.217-.794c.961-.35,2.149-.74,3.532-1.188s2.955-.958,4.7-1.49c6.978-2.186,16.729-4.846,27.271-8.479,5.277-1.794,10.2-3.8,14.6-5.782l3.193-1.5c1.027-.5,2-1.038,2.953-1.53,1.923-.956,3.621-2.014,5.2-2.935l1.151-.678c.367-.231.714-.474,1.057-.7l1.932-1.29c.6-.41,1.178-.759,1.67-1.137l1.354-1.027,1.882-1.413.5-.36A.949.949,0,0,1,550.987,410.729Z",
    transform: "translate(-476.841 -410.728)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_882",
    "data-name": "Group 882",
    transform: "translate(101.301 41.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_881",
    "data-name": "Group 881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_880",
    "data-name": "Group 880"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_879",
    "data-name": "Group 879"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M592.525,420.863a2.25,2.25,0,0,1-.583.305c-.384.177-.95.407-1.659.67a42.256,42.256,0,0,1-11.514,2.474c-.753.051-1.365.073-1.787.07a2.255,2.255,0,0,1-.657-.039,22.044,22.044,0,0,1,2.421-.294c1.493-.166,3.549-.456,5.79-.936s4.232-1.063,5.662-1.525A22.2,22.2,0,0,1,592.525,420.863Z",
    transform: "translate(-576.325 -420.857)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_886",
    "data-name": "Group 886",
    transform: "translate(34.091 9.921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_885",
    "data-name": "Group 885"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M519.167,368.213c.063.081-12.311,9.805-27.636,21.716s-27.8,21.5-27.867,21.424,12.309-9.8,27.639-21.718S519.1,368.132,519.167,368.213Z",
    transform: "translate(-463.663 -368.212)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(126.855 13.005)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_891",
    "data-name": "Group 891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_890",
    "data-name": "Group 890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_889",
    "data-name": "Group 889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M626.4,412.028a1.482,1.482,0,0,1-.039-.4c-.008-.311-.018-.692-.03-1.153-.01-1-.054-2.449-.141-4.236a101.852,101.852,0,0,0-5.127-27.381c-.565-1.7-1.048-3.063-1.4-4-.156-.434-.284-.793-.39-1.086a.2.2,0,1,1,.078-.032l.462,1.058c.4.92.926,2.274,1.528,3.963a90.791,90.791,0,0,1,5.142,27.465c.05,1.793.049,3.245.01,4.248-.019.461-.035.842-.048,1.154A1.479,1.479,0,0,1,626.4,412.028Z",
    transform: "translate(-619.16 -373.381)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_896",
    "data-name": "Group 896",
    transform: "translate(86.368 39.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    "data-name": "Group 895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_894",
    "data-name": "Group 894"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M551.294,430.082a.719.719,0,0,1,.161.119l.443.378c.392.328.935.851,1.687,1.462a45.283,45.283,0,0,0,6.794,4.569,44.7,44.7,0,0,0,11.334,4.262c.552.148,1.122.248,1.7.347s1.157.215,1.748.305c1.19.123,2.4.324,3.641.357a40.645,40.645,0,0,0,7.678-.23l1.946-.271,1.9-.388a35.8,35.8,0,0,0,10.2-3.864,26.187,26.187,0,0,0,8.869-8.1,22.368,22.368,0,0,0,3.275-7.445,22.066,22.066,0,0,0,.384-2.194c.028-.233.051-.422.07-.577a.7.7,0,0,1,.038-.2.717.717,0,0,1,0,.2c-.008.156-.017.347-.029.582a17.861,17.861,0,0,1-.309,2.22,21.8,21.8,0,0,1-3.188,7.573,26.184,26.184,0,0,1-8.922,8.268,34.987,34.987,0,0,1-6.608,2.938,34.6,34.6,0,0,1-3.7,1l-1.919.393-1.966.274a40.639,40.639,0,0,1-7.754.224c-1.256-.036-2.474-.242-3.674-.37-.6-.093-1.182-.211-1.763-.314s-1.156-.206-1.712-.358a44.084,44.084,0,0,1-11.39-4.377,42.265,42.265,0,0,1-6.757-4.7c-.738-.633-1.265-1.177-1.64-1.525l-.415-.408C551.333,430.137,551.288,430.087,551.294,430.082Z",
    transform: "translate(-551.293 -418.617)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_922",
    "data-name": "Group 922",
    transform: "translate(51.312 178.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_903",
    "data-name": "Group 903",
    transform: "translate(0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_899",
    "data-name": "Group 899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M536.339,439.161c-3.261-1.74-6.923-.711-10.044.341-2.077.7-4.236,1.809-6.345,1.215-1.525-.43-2.66-1.666-3.825-2.74a24.043,24.043,0,0,0-17.576-6.3,7.157,7.157,0,0,0-4.827,2.182c-3.2,3.47-.787,7.985,2.075,10.9a31.632,31.632,0,0,0,19.113,9.22c5.965.623,14.168-.2,20.218-2.792,3.73-1.6,5.643-6,3.686-9.551A6.124,6.124,0,0,0,536.339,439.161Z",
    transform: "translate(-492.2 -431.635)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(0.17 2.777)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_901",
    "data-name": "Group 901"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_900",
    "data-name": "Group 900"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M536.446,443.816c-3.261-1.74-6.923-.711-10.044.341-2.077.7-4.236,1.809-6.345,1.215-1.525-.429-2.66-1.666-3.825-2.74a24.044,24.044,0,0,0-17.576-6.3,7.158,7.158,0,0,0-4.827,2.182,5.564,5.564,0,0,0-1.345,2.432,12.683,12.683,0,0,0,3.42,5.694,31.638,31.638,0,0,0,19.113,9.221c5.965.623,14.168-.2,20.218-2.792a7.378,7.378,0,0,0,4.3-5.128,6.256,6.256,0,0,0-.617-1.646A6.124,6.124,0,0,0,536.446,443.816Z",
    transform: "translate(-492.485 -436.29)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_906",
    "data-name": "Group 906",
    transform: "translate(0 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_905",
    "data-name": "Group 905"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_904",
    "data-name": "Group 904"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M539.419,447.831a5.649,5.649,0,0,0-.8-1.932,6.317,6.317,0,0,0-1.745-1.707,6.964,6.964,0,0,0-3-1.148c-2.421-.285-5.227.735-8.345,1.578a13.047,13.047,0,0,1-5.066.8,6.721,6.721,0,0,1-2.606-.9,16.255,16.255,0,0,1-2.24-1.686,24.376,24.376,0,0,0-13.357-6.33,14.005,14.005,0,0,0-3.947-.023,8.62,8.62,0,0,0-3.053,1.065,7.771,7.771,0,0,0-1.87,1.586,18.826,18.826,0,0,0-1.2,1.738,6.759,6.759,0,0,1,1.073-1.847,7.659,7.659,0,0,1,1.874-1.686,8.722,8.722,0,0,1,3.131-1.163,14.06,14.06,0,0,1,4.042-.032,23.288,23.288,0,0,1,4.521,1.008,26.137,26.137,0,0,1,4.682,2.067,19.455,19.455,0,0,1,2.279,1.484c.726.569,1.413,1.193,2.118,1.8a15.99,15.99,0,0,0,2.176,1.644,6.305,6.305,0,0,0,2.438.851,12.818,12.818,0,0,0,4.906-.765c3.1-.812,5.957-1.828,8.489-1.5a7.016,7.016,0,0,1,4.848,3.069,4.53,4.53,0,0,1,.6,1.473A2.092,2.092,0,0,1,539.419,447.831Z",
    transform: "translate(-492.187 -436.014)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_909",
    "data-name": "Group 909",
    transform: "translate(0 2.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_908",
    "data-name": "Group 908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_907",
    "data-name": "Group 907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M539.419,447.831a5.649,5.649,0,0,0-.8-1.932,6.317,6.317,0,0,0-1.745-1.707,6.964,6.964,0,0,0-3-1.148c-2.421-.285-5.227.735-8.345,1.578a13.047,13.047,0,0,1-5.066.8,6.721,6.721,0,0,1-2.606-.9,16.255,16.255,0,0,1-2.24-1.686,24.376,24.376,0,0,0-13.357-6.33,14.005,14.005,0,0,0-3.947-.023,8.62,8.62,0,0,0-3.053,1.065,7.771,7.771,0,0,0-1.87,1.586,18.826,18.826,0,0,0-1.2,1.738,6.759,6.759,0,0,1,1.073-1.847,7.659,7.659,0,0,1,1.874-1.686,8.722,8.722,0,0,1,3.131-1.163,14.06,14.06,0,0,1,4.042-.032,23.288,23.288,0,0,1,4.521,1.008,26.137,26.137,0,0,1,4.682,2.067,19.455,19.455,0,0,1,2.279,1.484c.726.569,1.413,1.193,2.118,1.8a15.99,15.99,0,0,0,2.176,1.644,6.305,6.305,0,0,0,2.438.851,12.818,12.818,0,0,0,4.906-.765c3.1-.812,5.957-1.828,8.489-1.5a7.016,7.016,0,0,1,4.848,3.069,4.53,4.53,0,0,1,.6,1.473A2.092,2.092,0,0,1,539.419,447.831Z",
    transform: "translate(-492.187 -436.014)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_912",
    "data-name": "Group 912",
    transform: "translate(6.781 7.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_911",
    "data-name": "Group 911"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_910",
    "data-name": "Group 910"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M503.554,450.532a8.323,8.323,0,0,1,1.67-1.157,48.113,48.113,0,0,1,8.855-4.163,8.29,8.29,0,0,1,1.956-.548,10.627,10.627,0,0,1-1.846.838c-1.152.48-2.736,1.155-4.458,1.963s-3.251,1.6-4.355,2.18A10.7,10.7,0,0,1,503.554,450.532Z",
    transform: "translate(-503.553 -444.655)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_915",
    "data-name": "Group 915",
    transform: "translate(7.901 10.648)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_914",
    "data-name": "Group 914"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_913",
    "data-name": "Group 913"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M505.433,455.742a117.81,117.81,0,0,1,12.931-6.251,117.666,117.666,0,0,1-12.931,6.251Z",
    transform: "translate(-505.432 -449.484)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_918",
    "data-name": "Group 918",
    transform: "translate(6.122 8.683)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_917",
    "data-name": "Group 917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_916",
    "data-name": "Group 916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M517.741,455.828c-.064.1-3.54-1.971-7.762-4.631s-7.593-4.9-7.529-5,3.539,1.971,7.763,4.632S517.805,455.725,517.741,455.828Z",
    transform: "translate(-502.449 -446.191)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_921",
    "data-name": "Group 921",
    transform: "translate(11.917 6.993)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_920",
    "data-name": "Group 920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_919",
    "data-name": "Group 919"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M523.616,451.3a10.359,10.359,0,0,1-1.7-1.137c-1.022-.737-2.433-1.756-4.011-2.85s-3.028-2.058-4.077-2.757a10.4,10.4,0,0,1-1.662-1.194,8.83,8.83,0,0,1,1.826.931c1.094.634,2.577,1.56,4.163,2.659s2.973,2.163,3.951,2.965A8.829,8.829,0,0,1,523.616,451.3Z",
    transform: "translate(-512.163 -443.357)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1152",
    "data-name": "Group 1152",
    transform: "translate(93.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1131",
    "data-name": "Group 1131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_927",
    "data-name": "Group 927",
    transform: "translate(0 19.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_926",
    "data-name": "Group 926"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_925",
    "data-name": "Group 925"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_924",
    "data-name": "Group 924"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_923",
    "data-name": "Group 923"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M569.2,205.029a3.835,3.835,0,0,0,.128-1.641,4.577,4.577,0,0,0-.746-1.764,12.192,12.192,0,0,0-1.774-1.9,10.969,10.969,0,0,1-2.126-2.478,9.369,9.369,0,0,1-1.235-3.563,9.21,9.21,0,0,1,.406-4.148,25.545,25.545,0,0,1,1.855-4.008,19.557,19.557,0,0,0,1.709-3.933,7.209,7.209,0,0,0,.08-3.858c-.662-2.433-2.114-4.353-2.849-6.2a7.452,7.452,0,0,1-.6-4.636,4.17,4.17,0,0,1,.474-1.195c.152-.252.261-.363.276-.353a9.2,9.2,0,0,0-.5,1.6,7.532,7.532,0,0,0,.775,4.4c.756,1.772,2.255,3.642,3.007,6.236a7.753,7.753,0,0,1-.045,4.178,19.6,19.6,0,0,1-1.749,4.07,25.9,25.9,0,0,0-1.824,3.9,8.7,8.7,0,0,0-.417,3.874,8.959,8.959,0,0,0,1.106,3.364,10.819,10.819,0,0,0,1.979,2.42,11.717,11.717,0,0,1,1.76,2.028,4.615,4.615,0,0,1,.693,1.929,2.771,2.771,0,0,1-.153,1.286C569.321,204.918,569.213,205.036,569.2,205.029Z",
    transform: "translate(-563.367 -165.353)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_931",
    "data-name": "Group 931",
    transform: "translate(39.851 27.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_930",
    "data-name": "Group 930"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_929",
    "data-name": "Group 929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_928",
    "data-name": "Group 928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M630.168,198.319a5.9,5.9,0,0,0,5.4,3.554,7.111,7.111,0,0,0,5.765-3.2,9,9,0,0,0,1.239-6.583,10.51,10.51,0,0,1-.413-3.066c.168-1.46,1.231-2.665,1.595-4.089.656-2.563-1.218-5.271-3.657-6.3s-5.238-.709-7.787,0",
    transform: "translate(-630.168 -177.98)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(1.225 15.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_933",
    "data-name": "Group 933"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_932",
    "data-name": "Group 932"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M566.9,160.8c-2.35,2.363-1.453,5.465-.356,7.565s2.414,4.23,2.439,6.6c.026,2.423-1.305,4.625-1.97,6.955a13.006,13.006,0,0,0,.7,8.944c.967,2.089,2.478,3.887,3.457,5.97s1.34,4.705.009,6.583a4.118,4.118,0,0,0,2.9-2.32,8.078,8.078,0,0,0,.681-3.757c-.1-4.879-2.438-9.618-1.854-14.463.34-2.816,1.661-5.52,1.475-8.351s-1.853-5.329-3.057-7.908-1.918-5.8-.313-8.146",
    transform: "translate(-565.419 -158.469)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(0.578 8.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M572.236,146.541a9.4,9.4,0,0,0-7.125,4.426c-1.392,2.547-.913,6.153,1.466,7.817,2.243,1.569,5.423,1.052,7.727-.427a8.867,8.867,0,0,0,3.732-4.62,6.314,6.314,0,0,0-.893-5.751,4.929,4.929,0,0,0-5.416-1.654",
    transform: "translate(-564.336 -146.066)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(6.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M573.64,140.681a12.879,12.879,0,0,1,7.891-7.4,21.269,21.269,0,0,1,11.032-.539,63.509,63.509,0,0,1,10.65,3.334,23.648,23.648,0,0,1,7.189,3.715,15.839,15.839,0,0,1,4.359,6.662c1.741,4.732,1.814,8.2-.226,12.809-.888,2.007-.165,4.254-.96,6.3s-4.487,4.48-3.34,6.351",
    transform: "translate(-573.64 -132.274)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(4.259 6.686)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1037",
    "data-name": "Group 1037"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1036",
    "data-name": "Group 1036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1034",
    "data-name": "Group 1034"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_273",
    "data-name": "Path 273",
    d: "M607.145,196.206l-1.522-44.9a3.876,3.876,0,0,0-3.675-3.738l-20.82-4.081c-6.615-.34-10.551,8-10.61,14.619-.065,7.359.145,16.346,1.31,21.772,2.343,10.909,10.852,11.853,10.852,11.853,0-.022.24,4.257.464,8.1l-.355,16.91Z",
    transform: "translate(-570.506 -143.482)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_967",
    "data-name": "Group 967",
    transform: "translate(2.144 16.841)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_955",
    "data-name": "Group 955",
    transform: "translate(0.705 4.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_954",
    "data-name": "Group 954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_953",
    "data-name": "Group 953"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_952",
    "data-name": "Group 952"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_951",
    "data-name": "Group 951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_274",
    "data-name": "Path 274",
    d: "M575.283,180.359a1.412,1.412,0,0,0,1.438,1.35,1.352,1.352,0,0,0,1.386-1.351,1.414,1.414,0,0,0-1.436-1.351A1.353,1.353,0,0,0,575.283,180.359Z",
    transform: "translate(-575.283 -179.007)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_966",
    "data-name": "Group 966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_965",
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_958",
    "data-name": "Group 958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_957",
    "data-name": "Group 957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_956",
    "data-name": "Group 956"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_275",
    "data-name": "Path 275",
    d: "M574.126,173.35c.185.175,1.211-.675,2.73-.752,1.516-.1,2.673.621,2.828.426.076-.087-.12-.409-.625-.736a3.88,3.88,0,0,0-2.276-.569,3.723,3.723,0,0,0-2.161.829C574.176,172.931,574.036,173.273,574.126,173.35Z",
    transform: "translate(-574.1 -171.712)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(16.908 17.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(0 3.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_972",
    "data-name": "Group 972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_971",
    "data-name": "Group 971"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_970",
    "data-name": "Group 970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_969",
    "data-name": "Group 969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_968",
    "data-name": "Group 968"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_276",
    "data-name": "Path 276",
    d: "M598.849,179.992a1.414,1.414,0,0,0,1.437,1.351,1.352,1.352,0,0,0,1.386-1.351,1.414,1.414,0,0,0-1.436-1.351A1.352,1.352,0,0,0,598.849,179.992Z",
    transform: "translate(-598.849 -178.64)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988",
    transform: "translate(0.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M599.241,173.667c.186.174,1.213-.675,2.73-.752,1.516-.1,2.673.621,2.827.426.076-.087-.118-.409-.624-.736a3.875,3.875,0,0,0-2.275-.569,3.728,3.728,0,0,0-2.161.829C599.292,173.248,599.15,173.589,599.241,173.667Z",
    transform: "translate(-599.215 -172.029)",
    fill: "#263238"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1000",
    "data-name": "Group 1000",
    transform: "translate(8.32 17.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_999",
    "data-name": "Group 999"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_998",
    "data-name": "Group 998"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_997",
    "data-name": "Group 997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_996",
    "data-name": "Group 996"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_994",
    "data-name": "Group 994"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_993",
    "data-name": "Group 993"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_991",
    "data-name": "Group 991"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_990",
    "data-name": "Group 990"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M588.383,185.571a10.079,10.079,0,0,0-2.491-.311c-.39-.019-.761-.076-.841-.337a1.98,1.98,0,0,1,.2-1.163l.987-3.014c1.365-4.29,2.331-7.809,2.158-7.863s-1.42,3.381-2.785,7.671c-.327,1.058-.641,2.065-.938,3.03a2.246,2.246,0,0,0-.119,1.533.976.976,0,0,0,.668.533,2.625,2.625,0,0,0,.663.056A9.929,9.929,0,0,0,588.383,185.571Z",
    transform: "translate(-584.453 -172.881)",
    fill: "#263238"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(12.173 43.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1008",
    "data-name": "Group 1008"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1007",
    "data-name": "Group 1007"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1006",
    "data-name": "Group 1006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1005",
    "data-name": "Group 1005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1002",
    "data-name": "Group 1002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1001",
    "data-name": "Group 1001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M590.912,221.173a28.035,28.035,0,0,0,14.524-4.728s-3.309,7.767-14.377,7.333Z",
    transform: "translate(-590.912 -216.445)",
    fill: "#eb996e"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023",
    transform: "translate(16.226 12.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M597.716,166.5c.172.4,1.677.127,3.471.245,1.8.082,3.261.526,3.477.143.1-.183-.175-.558-.778-.926a6.05,6.05,0,0,0-5.294-.3C597.952,165.966,597.64,166.309,597.716,166.5Z",
    transform: "translate(-597.705 -165.195)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1033",
    "data-name": "Group 1033",
    transform: "translate(2.484 13.046)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1032",
    "data-name": "Group 1032"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1031",
    "data-name": "Group 1031"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M574.717,167.071c.286.33,1.313-.084,2.569-.169,1.254-.129,2.336.106,2.562-.268.1-.181-.089-.517-.571-.818a3.728,3.728,0,0,0-4.134.352C574.717,166.546,574.59,166.909,574.717,167.071Z",
    transform: "translate(-574.67 -165.35)",
    fill: "#263238"
  })))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(16.477 37.744)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(0.747 1.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1045",
    "data-name": "Group 1045"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1044",
    "data-name": "Group 1044"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1043",
    "data-name": "Group 1043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1042",
    "data-name": "Group 1042"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_282",
    "data-name": "Path 282",
    d: "M592.365,199.218a2.557,2.557,0,0,1,2.237-1.071,2.333,2.333,0,0,1,1.655.776,1.478,1.478,0,0,1,.2,1.682,1.714,1.714,0,0,1-1.831.57,5.367,5.367,0,0,1-1.868-.983,1.57,1.57,0,0,1-.427-.4.473.473,0,0,1-.027-.527",
    transform: "translate(-592.239 -198.143)",
    fill: "#eb996e"
  }))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_283",
    "data-name": "Path 283",
    d: "M595.3,195.543c-.231,0-.151,1.536-1.407,2.7s-2.9,1.082-2.9,1.3c-.016.1.381.279,1.073.26a3.834,3.834,0,0,0,2.427-1,3.335,3.335,0,0,0,1.082-2.257C595.594,195.9,595.4,195.528,595.3,195.543Z",
    transform: "translate(-590.987 -195.542)",
    fill: "#263238"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(5.838 3.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_284",
    "data-name": "Path 284",
    d: "M573.258,146.215c.719,3.452,6.255,3.712,9.674,2.849a11.208,11.208,0,0,0,10.1,3.693,3.036,3.036,0,0,1,1.51-.023,3.1,3.1,0,0,1,1.195,1.061,9.844,9.844,0,0,0,6.2,3.4,8.847,8.847,0,0,0,7.1,6.888s1.1-.622.45-5.047-.686-13.7-.686-13.7l-12.354-4.792L581.9,138.669S572.039,140.372,573.258,146.215Z",
    transform: "translate(-573.153 -138.669)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(7.667 5.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_285",
    "data-name": "Path 285",
    d: "M615.4,163.382a11.505,11.505,0,0,0-.922-3.05,7.823,7.823,0,0,0-6.662-4.318l-.193-.008-.058-.189a9.735,9.735,0,0,0-3.133-4.885,5.625,5.625,0,0,0-6.081-.678l-.324.186-.147-.357c-.051-.124-.106-.258-.162-.392a8.664,8.664,0,0,0-7.4-5.091,9.591,9.591,0,0,0-2.127.178,5,5,0,0,1-2.18.023,4.032,4.032,0,0,1-1.7-1.145,7.589,7.589,0,0,0-1.3-1.146,6.085,6.085,0,0,0-5.024-.679,10.314,10.314,0,0,0-1.769.823c-.014-.017.113-.14.375-.359a5.4,5.4,0,0,1,1.313-.7,6.22,6.22,0,0,1,5.353.532c1.056.585,1.73,1.834,2.9,2.158,1.171.3,2.606-.379,4.188-.28a9.205,9.205,0,0,1,7.971,5.437l.175.427-.471-.172a6.22,6.22,0,0,1,6.793.749,10.178,10.178,0,0,1,3.278,5.22l-.251-.2a8.26,8.26,0,0,1,4.6,1.749,7.9,7.9,0,0,1,2.323,2.983,7.536,7.536,0,0,1,.636,2.334A2.394,2.394,0,0,1,615.4,163.382Z",
    transform: "translate(-576.219 -141.217)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(5.222 10.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_286",
    "data-name": "Path 286",
    d: "M594.079,156.219a2.375,2.375,0,0,1-.889.35,9.1,9.1,0,0,1-2.6.291,10.669,10.669,0,0,1-7.728-3.617l.405.073-.353.184a8.314,8.314,0,0,1-4.9.734,7.963,7.963,0,0,1-3.7-1.633,7.53,7.53,0,0,1-1.793-2.037,2.208,2.208,0,0,1-.393-.912,12.9,12.9,0,0,0,2.464,2.582,7.877,7.877,0,0,0,3.511,1.407,7.983,7.983,0,0,0,4.529-.726l.324-.168.237-.123.169.2a10.734,10.734,0,0,0,7.256,3.586A21.312,21.312,0,0,0,594.079,156.219Z",
    transform: "translate(-572.119 -149.648)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1085",
    "data-name": "Group 1085",
    transform: "translate(13.858 10.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1084",
    "data-name": "Group 1084"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1083",
    "data-name": "Group 1083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1082",
    "data-name": "Group 1082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_287",
    "data-name": "Path 287",
    d: "M593.358,150.165c-.015.192-1.613.144-3.459.69-1.854.523-3.18,1.416-3.295,1.262-.118-.119,1.119-1.32,3.114-1.888C591.707,149.646,593.394,150,593.358,150.165Z",
    transform: "translate(-586.596 -149.907)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1090",
    "data-name": "Group 1090",
    transform: "translate(13.648 8.788)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1089",
    "data-name": "Group 1089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1088",
    "data-name": "Group 1088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1087",
    "data-name": "Group 1087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1086",
    "data-name": "Group 1086"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_288",
    "data-name": "Path 288",
    d: "M589.029,148.869c-.136.124-.725-.31-1.464-.78s-1.374-.832-1.317-1.008.853-.069,1.67.46S589.162,148.754,589.029,148.869Z",
    transform: "translate(-586.244 -147.006)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1095",
    "data-name": "Group 1095",
    transform: "translate(27.483 15.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1094",
    "data-name": "Group 1094"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1093",
    "data-name": "Group 1093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1092",
    "data-name": "Group 1092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1091",
    "data-name": "Group 1091"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M615.844,158.758c-.059.183-1.476-.19-3.226-.032-1.753.133-3.088.736-3.177.565-.1-.137,1.209-1.063,3.122-1.215C614.476,157.909,615.92,158.606,615.844,158.758Z",
    transform: "translate(-609.436 -158.05)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1100",
    "data-name": "Group 1100",
    transform: "translate(28.778 19.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1099",
    "data-name": "Group 1099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1098",
    "data-name": "Group 1098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1097",
    "data-name": "Group 1097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1096",
    "data-name": "Group 1096"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M620.1,167.153c.016.166-2.064.371-4.5-.342-2.442-.7-4.091-1.979-3.989-2.111.1-.165,1.836.822,4.171,1.485C618.107,166.869,620.1,166.959,620.1,167.153Z",
    transform: "translate(-611.605 -164.681)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1105",
    "data-name": "Group 1105",
    transform: "translate(38.793 23.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1104",
    "data-name": "Group 1104"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1103",
    "data-name": "Group 1103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1102",
    "data-name": "Group 1102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1101",
    "data-name": "Group 1101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M634.624,173.618c-.138.134-1.219-.951-2.958-1.443-1.729-.527-3.224-.2-3.268-.386-.085-.15,1.51-.821,3.452-.239C633.8,172.111,634.776,173.537,634.624,173.618Z",
    transform: "translate(-628.394 -171.317)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1110",
    "data-name": "Group 1110",
    transform: "translate(17.432 4.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1109",
    "data-name": "Group 1109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1108",
    "data-name": "Group 1108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1107",
    "data-name": "Group 1107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1106",
    "data-name": "Group 1106"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M619.069,145.3c-.053.021-.2-.359-.619-.922a6.55,6.55,0,0,0-2.327-1.814,21.306,21.306,0,0,0-9.724-1.616,39.576,39.576,0,0,0-9.815,1.868c-2.458.767-3.959,1.327-4,1.235a3.654,3.654,0,0,1,1-.53c.661-.3,1.63-.7,2.852-1.141a34.363,34.363,0,0,1,9.933-2.081,20.052,20.052,0,0,1,9.967,1.859,6.164,6.164,0,0,1,2.321,2.078A2.151,2.151,0,0,1,619.069,145.3Z",
    transform: "translate(-592.587 -140.274)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1115",
    "data-name": "Group 1115",
    transform: "translate(23.992 7.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1114",
    "data-name": "Group 1114"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1113",
    "data-name": "Group 1113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1112",
    "data-name": "Group 1112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1111",
    "data-name": "Group 1111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M624.737,153a18.307,18.307,0,0,0-1.87-3.006,13.4,13.4,0,0,0-7.195-4.223,24.8,24.8,0,0,0-8.523-.175,30.956,30.956,0,0,1-3.566.449,14.558,14.558,0,0,1,3.5-.9,22.21,22.21,0,0,1,8.738,0,12.99,12.99,0,0,1,7.409,4.57,8.638,8.638,0,0,1,1.29,2.34A2.408,2.408,0,0,1,624.737,153Z",
    transform: "translate(-603.584 -144.696)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1120",
    "data-name": "Group 1120",
    transform: "translate(0.284 10.163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1119",
    "data-name": "Group 1119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1118",
    "data-name": "Group 1118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1117",
    "data-name": "Group 1117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1116",
    "data-name": "Group 1116"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M567.75,161.779a3.964,3.964,0,0,1-2.121-1.406,6.569,6.569,0,0,1,2.219-10.571,3.963,3.963,0,0,1,2.507-.434,18.523,18.523,0,0,0-2.306.848,6.385,6.385,0,0,0-2.07,9.858A18.319,18.319,0,0,0,567.75,161.779Z",
    transform: "translate(-563.842 -149.31)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1125",
    "data-name": "Group 1125",
    transform: "translate(46.052 25.463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1124",
    "data-name": "Group 1124"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1123",
    "data-name": "Group 1123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1122",
    "data-name": "Group 1122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1121",
    "data-name": "Group 1121"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M644.572,186.873c-.061-.1,1.053-.688,2.628-1.87a7.994,7.994,0,0,0,2.218-2.537,4.384,4.384,0,0,0,.19-3.875,5.169,5.169,0,0,0-2.831-2.747,5.921,5.921,0,0,0-3.3-.211,11.532,11.532,0,0,0-2.909,1.242c-.025-.028.171-.278.623-.63a6.411,6.411,0,0,1,2.178-1.059,6.117,6.117,0,0,1,3.62.095,5.63,5.63,0,0,1,3.222,3.054,4.909,4.909,0,0,1-.259,4.416,7.919,7.919,0,0,1-2.473,2.624,15.23,15.23,0,0,1-2.079,1.188C644.886,186.8,644.594,186.912,644.572,186.873Z",
    transform: "translate(-640.561 -174.957)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1130",
    "data-name": "Group 1130",
    transform: "translate(41.307 37.442)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1129",
    "data-name": "Group 1129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1128",
    "data-name": "Group 1128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1127",
    "data-name": "Group 1127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1126",
    "data-name": "Group 1126"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M641.877,195.038a3.3,3.3,0,0,1,.508.95,24.027,24.027,0,0,1,1.034,2.744,14.591,14.591,0,0,1,.692,4.329,9.341,9.341,0,0,1-1.483,5.189,6.706,6.706,0,0,1-4.56,2.889,4.828,4.828,0,0,1-4.162-1.419,4.362,4.362,0,0,1-1.289-2.681,1.893,1.893,0,0,1,.137-1.081c.059.007,0,.391.115,1.047a4.542,4.542,0,0,0,5.118,3.539,6.235,6.235,0,0,0,4.1-2.661,9.032,9.032,0,0,0,1.422-4.832,15.445,15.445,0,0,0-.536-4.2C642.347,196.5,641.772,195.076,641.877,195.038Z",
    transform: "translate(-632.609 -195.037)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1151",
    "data-name": "Group 1151",
    transform: "translate(32.895 16.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1135",
    "data-name": "Group 1135",
    transform: "translate(0 0.464)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1134",
    "data-name": "Group 1134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1133",
    "data-name": "Group 1133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1132",
    "data-name": "Group 1132"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M619.149,160.516c-1.373,2.735-.323,6.048,1.084,8.765s3.2,5.409,3.319,8.467c.2,5.122-4.379,9.65-3.746,14.736a7.653,7.653,0,0,0,5.771,6.355c-2.423-1.629-2.643-5.192-1.717-7.961s5.408-10.066,6.058-12.913c2.182-9.562,1.25-10.673-2.092-14.035",
    transform: "translate(-618.507 -160.516)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1140",
    "data-name": "Group 1140",
    transform: "translate(1.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1139",
    "data-name": "Group 1139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1138",
    "data-name": "Group 1138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1137",
    "data-name": "Group 1137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1136",
    "data-name": "Group 1136"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M629.64,167.019a2.986,2.986,0,0,1-1.775.076,7.364,7.364,0,0,1-6.046-5.58,2.993,2.993,0,0,1-.067-1.776,11.351,11.351,0,0,1,.521,1.644,8.044,8.044,0,0,0,5.686,5.249A11.188,11.188,0,0,1,629.64,167.019Z",
    transform: "translate(-621.663 -159.739)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1145",
    "data-name": "Group 1145",
    transform: "translate(1.37 1.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1144",
    "data-name": "Group 1144"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1142",
    "data-name": "Group 1142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1141",
    "data-name": "Group 1141"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M625.311,196.279c-.015.018-.131-.057-.341-.218a4.913,4.913,0,0,1-.8-.835,6.533,6.533,0,0,1-1.294-4.035,6.18,6.18,0,0,1,.744-2.9,13.261,13.261,0,0,1,2.128-2.633,9.743,9.743,0,0,0,2.068-2.874,8.259,8.259,0,0,0,.684-3.692,7.848,7.848,0,0,0-1.048-3.6,20.224,20.224,0,0,0-2.136-2.909,21.288,21.288,0,0,1-3.468-5.223,11.543,11.543,0,0,1-1.033-4.107,4.252,4.252,0,0,1,.111-1.547,14.136,14.136,0,0,0,1.352,5.456,22.179,22.179,0,0,0,3.51,5.024,20,20,0,0,1,2.235,2.982,8.392,8.392,0,0,1,1.147,3.895,8.8,8.8,0,0,1-.753,3.989,10.187,10.187,0,0,1-2.223,3.034,13.216,13.216,0,0,0-2.09,2.479,5.791,5.791,0,0,0-.754,2.637,6.6,6.6,0,0,0,1.034,3.871C624.917,195.886,625.354,196.233,625.311,196.279Z",
    transform: "translate(-620.804 -161.711)",
    fill: "#455a64"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1150",
    "data-name": "Group 1150",
    transform: "translate(6.856 6.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1149",
    "data-name": "Group 1149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1148",
    "data-name": "Group 1148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1147",
    "data-name": "Group 1147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1146",
    "data-name": "Group 1146"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M634.12,171.338c.026-.028.3.162.7.592a7.759,7.759,0,0,1,1.368,2.1,11.808,11.808,0,0,1,.35,8.162,20.3,20.3,0,0,1-4.133,7.079,12.773,12.773,0,0,1-2.4,2.385,25.124,25.124,0,0,1,2.035-2.683A22.835,22.835,0,0,0,635.9,182a12.162,12.162,0,0,0-.146-7.783A17.383,17.383,0,0,0,634.12,171.338Z",
    transform: "translate(-630 -171.335)",
    fill: "#455a64"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(37.535 68.449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(0 24.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1168",
    "data-name": "Group 1168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1156",
    "data-name": "Group 1156",
    transform: "translate(0.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1155",
    "data-name": "Group 1155"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1154",
    "data-name": "Group 1154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1153",
    "data-name": "Group 1153"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M523.591,299.884l-6.161-11.366a2.339,2.339,0,0,0-2.056-1.225H471.516a2.339,2.339,0,0,0-2.069,1.249h0l43.476,29.218,19.237,2.208h0a2.779,2.779,0,0,0,.037-2.517Z",
    transform: "translate(-469.447 -287.294)",
    fill: "#263238"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1159",
    "data-name": "Group 1159",
    transform: "translate(55.413 23.461)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1158",
    "data-name": "Group 1158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1157",
    "data-name": "Group 1157"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M607.3,341.764c-7.7-3.358-16.56-3.845-23.8-8.108-2.769-1.63-5.222-3.771-8.054-5.29s-6.272-2.372-9.26-1.19-5.254,5.668-3.7,8.484c.593,1.5,3.427,2.907,5.034,2.769s3.128-.8,4.728-1c3.436-.436,6.738,1.26,9.836,2.807a162.788,162.788,0,0,0,20.649,8.595,11.1,11.1,0,0,0,5.108.839c1.724-.257,3.421-1.558,3.535-3.3C611.516,344.185,609.309,342.639,607.3,341.764Z",
    transform: "translate(-561.979 -326.621)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(0 1.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1162",
    "data-name": "Group 1162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1160",
    "data-name": "Group 1160"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M532.016,320.814,516.635,290.7a2.4,2.4,0,0,0-2.139-1.309h-45.4l16.916,30.467,46.008.959Z",
    transform: "translate(-469.092 -289.388)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1167",
    "data-name": "Group 1167",
    transform: "translate(26.782 9.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1166",
    "data-name": "Group 1166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1165",
    "data-name": "Group 1165"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1164",
    "data-name": "Group 1164"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M514.536,305.779a1.471,1.471,0,1,0-.228-2.067A1.471,1.471,0,0,0,514.536,305.779Z",
    transform: "translate(-513.985 -303.161)",
    fill: "#ebebeb"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1172",
    "data-name": "Group 1172",
    transform: "translate(36.774 9.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1171",
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1170",
    "data-name": "Group 1170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1169",
    "data-name": "Group 1169"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M561.247,310.851l-4.569-3.528a9.885,9.885,0,0,0-7.7-3.682h-2.489l-1.7,1.911s-12.184.531-12.633,2.034l-.011.485-.007.284,10.421.7s-8.865-.027-9.4-.008c-.584.021-2.474-.149-2.435.892.032.855,1.043,1.53,2.576,1.753.63.092,8.309.759,8.309.759s-8.063-.077-8.453-.079c-.947,0-.827,1.515-.264,1.7.445.15,11.271,3.31,11.271,3.31a6.565,6.565,0,0,1-3.306,1.114c-1.486-.106-4.033-2.017-4.564-1.114s-.425,1.433-.106,1.645a37.853,37.853,0,0,0,4.989,2.335c1.167.319,10.7,1.827,10.7,1.827l7.906-1.013Z",
    transform: "translate(-530.734 -303.641)",
    fill: "#ffbe9d"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(46.686 11.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1173",
    "data-name": "Group 1173"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_306",
    "data-name": "Path 306",
    d: "M547.35,306.982a68.467,68.467,0,0,1,8.552-.045,68.484,68.484,0,0,1-8.552.045Z",
    transform: "translate(-547.35 -306.824)",
    fill: "#eb996e"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(63.244 0.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_307",
    "data-name": "Path 307",
    d: "M579.148,288.666l33.541,6.384,3.365-42.17s9.046-7.608,13.831-2.417a18.753,18.753,0,0,1,4.832,14.4c-.307,3.061-3.354,39.1-5.882,45.2-3.536,8.527-12.591,8.069-15.119,7.449s-38.609-17.683-38.609-17.683Z",
    transform: "translate(-575.106 -248.65)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187",
    transform: "translate(99.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183",
    transform: "translate(0.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308",
    "data-name": "Path 308",
    d: "M639.217,252c-1.182,9.522-3.5,24.093-3.635,33.687,0,.389,23.068,2.317,23.068,2.317s1.2-21.724.333-28.329c-.986-7.5-6.6-12.664-6.6-12.664h-7.239Z",
    transform: "translate(-635.582 -247.012)",
    fill: "#ff725e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(0 13.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M658.539,297.251a2.722,2.722,0,0,1-.468-.016l-1.337-.106-4.926-.446-16.351-1.595-.15-.014.01-.151c.02-.3.042-.614.063-.935.466-6.633.887-12.635,1.195-17.016.166-2.153.3-3.906.4-5.154q.078-.879.124-1.4a2.878,2.878,0,0,1,.064-.487,2.933,2.933,0,0,1,0,.491q-.024.524-.066,1.4c-.072,1.25-.174,3-.3,5.161-.285,4.384-.674,10.388-1.1,17.024-.021.32-.044.639-.063.935l-.139-.165,16.342,1.689,4.917.543,1.332.162A2.734,2.734,0,0,1,658.539,297.251Z",
    transform: "translate(-635.306 -269.931)",
    fill: "#263238"
  }))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess2);
export default __webpack_public_path__ + "static/media/process-2.d348b5ad42febab45fe749e3cae1c2a0.svg";
export { ForwardRef as ReactComponent };